<template>
  <div id="home"
       class="home">

    <div class="img-box">
      <div class="baseTi">
        <img class="baseBg"
             src="../../picture/Audi_S3_Banner_Mobile_20210223_V5.jpg" />
      </div>
      <div class="overlayTxt">
        <div class="tWrap">
          <div class="tRow">
            <div class="col tCell">
              <div class="txtInner">
                <div class="h1-logo-fff">
                  <div class="h1-logo-fff none1024">
                    <img src="../../img/header_logo_2_000.png" />
                  </div>
                </div>
                <p><strong>非凡體驗</strong></p>
                <h1><strong>全新一代 <span class="audiTxtExtendedBold">Audi S3 </span>強勢抵港 <br /> <span class="audiTxtExtendedBold">HK$526,488 </span>起 </strong><span class="audiTxtExtendedBold"></span></h1>

                <!-- <div class="ctaRow none1024">
                  <a v-preventReClick="3000" class="more mmo"
                    v-scroll-to="{
                      el: el,
                      container: 'body',
                      duration: 500,
                      easing: 'ease',
                      offset: 0,
                      force: true,
                      cancelable: true,
                      onStart: false,
                      onDone: false,
                      onCancel: false,
                      x: false,
                      y: true
                  }">登記及瞭解詳情</a>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-box w86">
      <div class="inner">

        <h1 class="none1024">
          更動感、更震撼、更多裝備 <br />
          全新<font class="audiTxtExtendedBold"> Audi S3 Sportback</font> 和 <font class="audiTxtExtendedBold">S3 Sedan</font>
        </h1>
        <br />

        <p class="font28"
           style="margin-top: 10px !important">
          全新 S3 Sportback 和 S3 Sedan 擁有更運動化的外形設計，立體車身線條配合 Black Styling 套件，突顯跑格及科技感。採用 S 車系標誌性設計元素，包括鋁合金側鏡，四出排氣尾喉設計等標準配備。 型格外表下藏著強悍動力，可輸出 310 匹馬力， 0 至 100 公里加速只需 4.8 秒。搭配 quattro 四輪驅動系統及 Damper Control 運動懸掛連減震控制系統，內外均展現扣人心弦的豪華設備和高速性能。
          <br />
          <br />
          全新一代 Audi S3 現已抵港，立即預約專屬您的試駕服務！
        </p>
        <!-- -->

        <!-- 2020-11-27, 2020-12-3， 2020-12-18 -->
        <!-- <p class="font28">
          <strong>日期 : </strong> 12 月 18 至 20 日 ( 本週五至日 )<br/>
          <br/>
          <strong>奧迪太古城旗艦陳列室</strong> <br/>
          <strong>地點 : </strong> 香港太古城太古灣道 12 號地下<br/>
          <strong>時間 : </strong> 上午 9 時至晚上 8 時 <br/>
          <br/>
          <strong>奧迪認可易手車中心</strong> <br/>
          <strong>地點 : </strong> 香港灣仔告士打道 39 號夏愨大廈地下 A 舖<br/>
          <strong>時間 : </strong> 上午 10 時至晚上 7 時<br/>
          <br/>
          <strong>元朗二手車中心</strong> <br/>
          <strong>地點 : </strong> 新界元朗青山公路屏山段 ( 塘坊村輕鐵站對面 )<br/>
          <strong>時間 : </strong> 上午 9 時至晚上 7 時<br/>
          <br/>
          更多有關資料，歡迎致電 : <span class="audiTxtTypeNormal">2291 0000</span> <br/>
          *優惠受條款及細則約束
        </p> -->
        <!-- -->

        <!-- <div class="btn-box register block1024" style="display: none;">
            <div class="ctaRow" >
              <a v-preventReClick="3000" class="button"
                v-scroll-to="{
                  el: el,
                  container: 'body',
                  duration: 500,
                  easing: 'ease',
                  offset: 0,
                  force: true,
                  cancelable: true,
                  onStart: false,
                  onDone: false,
                  onCancel: false,
                  x: false,
                  y: true
              }">登記及瞭解詳情</a>
            </div>
          </div> -->
        <br />
        <br />

      </div>
    </div>

    <!-- <div class="text-box w86" >
      <div class="inner" style="padding: 0">
        <h4>馬上訂購可享：</h4>
        <div class="text-ul font28">
          <div class="text-li">1. 優惠價 HK$526,488*</div>
          <div class="text-li">2. 可選限量顏色 — Python Yellow 及 Turbo Blue</div>
          <div class="text-li">3. 可選限量特別版 Vorsprung Edition</div>
          <div class="text-li">4. 成為 VIP 獲取新車發佈資訊及預留首批專業試駕及賽道體驗日^</div>
          <div class="text-li">5. 免費五年原廠保用 <span>(Factory Warranty)</span>。每年售後服務 <span>(Regular Maintenance Service)</span> 特別價格更低至 HK$3,988 </div>
        </div>
        <br/>
        <div class="text-official">
          * 以 2021 最新汽車首次登記稅計算。<br/>
          ^ 受條款及細則約束；試駕或賽道活動舉辦時間視乎疫情情況而定。
        </div>
        <br/><br/>
        <div class="btn-box register">
          <div class="ctaRow" >
            <a v-preventReClick="3000" class="button"
              v-scroll-to="{
                el: el,
                container: 'body',
                duration: 500,
                easing: 'ease',
                offset: 0,
                force: true,
                cancelable: true,
                onStart: false,
                onDone: false,
                onCancel: false,
                x: false,
                y: true
            }">登記及瞭解詳情</a>
          </div>
        </div>
      </div>
    </div> -->

    <div class="nm-box">
      <h5>高性能數字</h5>
      <div class="nm-box-ul">
        <div class="nm-box-li">
          <p class="nm-box-title"><span>輸出</span></p>
          <div class="nm-box-number">
            <div class="nm-box-figure audiTxtExtendedBold"><span>310</span></div>
            <div class="nm-box-unit">馬力</div>
          </div>
          <p class="nm-box-m"></p>
        </div>
        <div class="nm-box-li">
          <p class="nm-box-title"><span>加速</span></p>
          <div class="nm-box-number">
            <div class="nm-box-figure audiTxtExtendedBold"><span>4.8</span></div>
            <span class="nm-box-unit">秒</span>
          </div>
          <p class="nm-box-m">0 - 100 公里</p>
        </div>
        <div class="nm-box-li">
          <p class="nm-box-title"><span>最高時速</span></p>
          <div class="nm-box-number">
            <div class="nm-box-figure audiTxtExtendedBold"><span>250</span></div>
            <div class="nm-box-unit">公里/<br class="block360"
                  style="display: none;">小時</div>
          </div>
          <p class="nm-box-m"></p>
        </div>
      </div>
    </div>

    <div class="car-boxbottom">
      <h3><strong>
          <font class="audiTxtExtendedBold"></font> 標準版特點
        </strong></h3>
      <ul>
        <li v-for="(item, index) in cardSlideListBottom"
            :key="index">
          <div class="tmbRow">
            <a>
              <img :src="item.img" />
            </a>
          </div>
          <div class="descRow">
            <h4>{{item.title}}</h4>
            <!-- <div class="car-p">
              <div class="car-p-li ff" v-for="(arry, indexArry) in item.arr" :key="indexArry">
                {{arry}}
              </div>
            </div> -->
          </div>
        </li>
      </ul>
    </div>

    <div class="car-boxbottom">
      <h3><strong>
          <font class="audiTxtExtendedBold">Vorsprung</font> 特別版特點
        </strong></h3>
      <ul>
        <li v-for="(item, index) in carsQList"
            :key="index">
          <div class="tmbRow">
            <a>
              <img :src="item.img" />
            </a>
          </div>
          <div class="descRow">
            <h4>{{item.title}}</h4>
            <!-- <div class="car-p">
              <div class="car-p-li ff" v-for="(arry, indexArry) in item.arr" :key="indexArry">
                {{arry}}
              </div>
            </div> -->
          </div>
        </li>
      </ul>

      <div class="text-box w86"
           style="margin-bottom: 36px;">
        <div class="inner"
             style="padding: 0">
          <p class="font28"
             style="margin-top: 0 !important; margin-bottom: 10px !important">*實際販售之規格配備可能與圖片有所不同</p>
        </div>
      </div>
    </div>

    <div class="text-box w86">
      <div class="inner"
           style="padding: 0">
        <div class="text-pdf">
          <span><a @click="showPopupPdf(0)">下載 S3 Sportback 規格表 ></a></span>
          <span><a @click="showPopupPdf(1)">下載 S3 Sedan 規格表 ></a></span>
        </div>
        <!-- 
        <h4>預售禮遇</h4>
        <div class="text-ul font28">
          在 2 月 28 日前支付 HK$10,000 訂金可享：
          <div class="text-li">1. 預售優惠價*</div>
          <div class="text-li">2. 新車發佈限量顏色 — Python Yellow 及 Turbo Blue</div>
          <div class="text-li">3. 限量 Vorsprung 特別版</div>
          <div class="text-li">4. 登記成為 VIP 以獲取 Audi Sport 最新汽車發佈資訊及出席賽道體驗日**</div>
          <div class="text-li">5. 出席新車首展並享有一對一試駕服務</div>
        </div>
        <div class="text-official">
          *最多較 2021 年官方建議零售價低 8%。受條款及細則約束。<br/>
          ** 視乎疫情情況而定
        </div> -->
      </div>
    </div>

    <br />
    <!-- <div class="blog-wrapper">
      <h3><strong><font class="audiTxtExtendedBold">Audi S3</font> 特點</strong></h3>
      <div class="ul">
        <div class="li" v-for="(item, index) in cardSlideList" :key="index">
          <div class="box">
            <img :src="item.img" class="animate__animated animate__fadeIn hidden-xs">
            <div class="tent">
              <strong>{{item.title}}</strong> 
              <p>{{item.text}}</p>
            </div>
          </div>
        </div>
      </div> 
      <p class="font28" style="margin-top: 0 !important; margin-bottom: 10px !important">*實際販售之規格配備可能與圖片有所不同</p>
    </div> -->

    <br />

    <!-- <div class="text-box w86" style="margin-bottom: 54px;">
      <div class="inner" style="padding: 0">
        <p class="font28" style="margin-top: 10px !important">
         奧迪承諾所有新車車主均享有 5 年或十萬公里汽車保用（以較先到達者為準），以及 12 年車身防鏽保養，務求為車主帶來無憂的駕駛體驗和保障，立即行動與奧迪結伴出遊！
        </p>
        <br/>
        <p class="font28" style="margin-top: 10px !important">
          <strong>奧迪旗艦陳列室</strong> <br/>
          香港太古城太古灣道 12 號地下<br/>
          Audi 銷售服務熱線︰2291 0000 <br/>
        </p>
      </div>
    </div> -->

    <div class="con-box"
         id="conbox">
      <h2>立即登記獲取更多全新<span class="audiTxtExtendedBold"> Audi S3 </span> 資訊，同時預約專屬您的試駕服務！</h2>
      <p>*必須填寫</p>
      <form ref="formData">
        <div class="formGroup">
          <div class="formRow row04">
            <div class="tWrap">
              <div class="tRow">
                <div class="lCol tCell">
                  <div class="fieldInner">
                    <div :class="['inputFieldGroup', errors.has('extend2_cn') == true ? 'hasError' : '']">
                      <label>了解型號<sup>*</sup></label>
                      <div :class="['inputField', 'selection', errors.has('extend2_cn') == true ? 'hasError' : '']">
                        <select name="extend2_cn"
                                v-model="formData.extend2"
                                v-validate="'required'"
                                @focus="selectFn($event)"
                                @blur="selectBr($event)">
                          <option selected
                                  disabled
                                  value="">了解型號</option>
                          <option value="S3 Sportback">S3 Sportback</option>
                          <option value="S3 Sedan">S3 Sedan</option>
                        </select>
                      </div>
                      <div class="errorField"
                           v-show="errors.has('extend2_cn')">{{ errors.first('extend2_cn') }}</div>
                    </div>
                  </div>
                </div>
                <div class="sepCol tCell">&nbsp;</div>
                <div class="rCol tCell">
                </div>
              </div>
            </div>
          </div>

          <div class="formRow row04">
            <div class="tWrap">
              <div class="tRow">
                <div class="lCol tCell">
                  <div class="fieldInner">
                    <!-- <div :class="['inputFieldGroup', errors.has('cch_cn') == true ? 'hasError' : '']">
                            <label>稱謂<sup>*</sup></label>
                            <div :class="['inputField', 'selection', errors.has('cch_cn') == true ? 'hasError' : '']">
                                <select name="cch_cn" v-model="formData.cch"  v-validate="'required'" @focus="selectFn($event)" @blur="selectBr($event)">
                                    <option selected disabled value="">稱謂</option>
                                    <option value="Mr">先生</option>
                                    <option value="Mrs">女士</option>
                                    <option value="Ms">小姐</option>
                                    <option value="Dr">博士</option>
                                    <option value="Professor">教授</option>
                                </select>
                            </div>
                            <div class="errorField" v-show="errors.has('cch_cn')">{{ errors.first('cch_cn') }}</div>
                        </div> -->
                    <div :class="['inputFieldGroup', errors.has('surname_cn') == true ? 'hasError' : '']">
                      <label>姓氏<sup>*</sup></label>
                      <div :class="['inputField', errors.has('surname_cn') == true ? 'hasError' : '']">
                        <input type="text"
                               name="surname_cn"
                               v-model="formData.surname"
                               v-validate="'required'"
                               placeholder="姓氏">
                      </div>
                      <div class="errorField"
                           v-show="errors.has('surname_cn')">{{ errors.first('surname_cn') }}</div>
                    </div>
                  </div>
                </div>
                <div class="sepCol tCell">&nbsp;</div>
                <div class="rCol tCell">
                  <div class="fieldInner">
                    <div :class="['inputFieldGroup', errors.has('name_cn') == true ? 'hasError' : '']">
                      <label>名字<sup>*</sup></label>
                      <div :class="['inputField', errors.has('name_cn') == true ? 'hasError' : '']">
                        <input type="text"
                               name="name_cn"
                               v-validate="'required'"
                               v-model="formData.name"
                               placeholder="名字">
                      </div>
                      <div class="errorField"
                           v-show="errors.has('name_cn')">{{ errors.first('name_cn') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="formRow row04">
            <div class="tWrap">
              <div class="tRow">
                <div class="lCol tCell">
                  <div class="fieldInner">
                    <div class="inputFieldGroup">
                      <label>預約日期</label>

                      <div :class="['inputField', errors.has('selDate_cn') == true ? 'hasError' : '']">
                        <!-- {{date}} -->
                        <input type="text"
                               name="selDate_cn"
                               v-validate="'required'"
                               @focus="focusData"
                               v-model="formData.selDate"
                               style="cursor: pointer;"
                               placeholder="預約日期"
                               readonly>
                        <mu-date-picker v-if="selDate_Yn"
                                        class="datePicker"
                                        @change="changeDate"
                                        :no-display="true"
                                        :should-disable-date="allowedDates"
                                        :min-date="minDate"
                                        :max-date="maxDate"
                                        :date.sync="selDate">
                          <span class="close"
                                @click="closeData">a</span>
                        </mu-date-picker>
                      </div>
                      <div class="errorField"
                           v-show="errors.has('selDate_cn')">{{ errors.first('selDate_cn') }}</div>
                    </div>
                  </div>
                </div>
                <div class="sepCol tCell">&nbsp;</div>
                <div class="rCol tCell">
                  <div class="fieldInner">
                    <div :class="['inputFieldGroup', errors.has('selTime_cn') == true ? 'hasError' : '']"
                         v-if="formData.selDate != ''">
                      <label>預約時段</label>
                      <div :class="['inputField', 'selection', errors.has('selTime_cn') == true ? 'hasError' : '']">
                        <select name="selTime_cn"
                                v-model="formData.selTime"
                                v-validate="'required'"
                                @focus="selectFn($event)"
                                @blur="selectBr($event)">
                          <option selected
                                  disabled
                                  value="">預約時段</option>
                          <option value="09:00-10:00">09:00-10:00</option>
                          <option value="10:00-11:00">10:00-11:00</option>
                          <option value="11:00-12:00">11:00-12:00</option>
                          <option value="12:00-13:00">12:00-13:00</option>
                          <option value="13:00-14:00">13:00-14:00</option>
                          <option value="14:00-15:00">14:00-15:00</option>
                          <option value="15:00-16:00">15:00-16:00</option>
                          <option value="16:00-17:00">16:00-17:00</option>
                          <option value="17:00-18:00">17:00-18:00</option>
                        </select>
                      </div>
                      <div class="errorField"
                           v-show="errors.has('selTime_cn')">{{ errors.first('selTime_cn') }}</div>
                    </div>
                  </div>
                  <!-- <div class="fieldInner">
                      <div :class="['inputFieldGroup', errors.has('email') == true ? 'hasError' : '']">
                        <label>電郵</label>
                        <div :class="['inputField', errors.has('email') == true ? 'hasError' : '']">
                          <input type="text" name="email" v-validate="'email_cn'" v-model="formData.email" placeholder="電郵">
                        </div>
                        <div class="errorField" v-show="errors.has('email')">{{ errors.first('email') }}</div>
                      </div>
                    </div> -->
                  <!-- <div class="fieldInner">
                        <div class="inputFieldGroup" id="input_group_phone_no">
                            <label>Other contact number</label>
                            <div class="inputField"><input type="number" name="phone_no" id="phone_no" placeholder="Other contact number (if any)"></div>
                            <div class="errorField" id="error_phone_no"></div>
                        </div>
                    </div> -->
                </div>
              </div>
            </div>
          </div>

          <div class="formRow row03 row04">
            <div class="tWrap">
              <div class="tRow">
                <!-- <div class="lCol tCell">
                  <label>出生日期</label>
                  <div class="fieldInner">
                    <div class="inputFieldGroup">
                      <div class="inputField selection">
                        <select name="birthDay" v-model="formData.birthDay" @focus="selectFn($event)" @blur="selectBr($event)">
                          <option selected disabled value="">日期</option>
                          <option value="01">01</option>
                          <option value="02">02</option>
                          <option value="03">03</option>
                          <option value="04">04</option>
                          <option value="05">05</option>
                          <option value="06">06</option>
                          <option value="07">07</option>
                          <option value="08">08</option>
                          <option value="09">09</option>
                          <option value="10">10</option>
                          <option value="11">11</option>
                          <option value="12">12</option>
                          <option value="13">13</option>
                          <option value="14">14</option>
                          <option value="15">15</option>
                          <option value="16">16</option>
                          <option value="17">17</option>
                          <option value="18">18</option>
                          <option value="19">19</option>
                          <option value="20">20</option>
                          <option value="21">21</option>
                          <option value="22">22</option>
                          <option value="23">23</option>
                          <option value="24">24</option>
                          <option value="25">25</option>
                          <option value="26">26</option>
                          <option value="27">27</option>
                          <option value="28">28</option>
                          <option value="29">29</option>
                          <option value="30">30</option>
                          <option value="31">31</option>
                        </select>
                      </div>
                    </div>
                    <div class="inputFieldGroup">
                        <div class="inputField selection">
                            <select name="birthMonth" v-model="formData.birthMonth" @focus="selectFn($event)" @blur="selectBr($event)">
                                <option selected disabled value="">月份</option>
                                <option value="1">一月</option>
                                <option value="2">二月</option>
                                <option value="3">三月</option>
                                <option value="4">四月</option>
                                <option value="5">五月</option>
                                <option value="6">六月</option>
                                <option value="7">七月</option>
                                <option value="8">八月</option>
                                <option value="9">九月</option>
                                <option value="10">十月</option>
                                <option value="11">十一月</option>
                                <option value="12">十二月</option>
                            </select>
                        </div>
                    </div>
                    <div class="inputFieldGroup">
                        <div class="inputField selection">
                            <select name="birthYear" v-model="formData.birthYear" @focus="selectFn($event)" @blur="selectBr($event)">
                            <option selected disabled value="">年份</option>
                            <option value="2002">2002</option><option value="2001">2001</option><option value="2000">2000</option><option value="1999">1999</option><option value="1998">1998</option><option value="1997">1997</option><option value="1996">1996</option><option value="1995">1995</option><option value="1994">1994</option><option value="1993">1993</option><option value="1992">1992</option><option value="1991">1991</option><option value="1990">1990</option><option value="1989">1989</option><option value="1988">1988</option><option value="1987">1987</option><option value="1986">1986</option><option value="1985">1985</option><option value="1984">1984</option><option value="1983">1983</option><option value="1982">1982</option><option value="1981">1981</option><option value="1980">1980</option><option value="1979">1979</option><option value="1978">1978</option><option value="1977">1977</option><option value="1976">1976</option><option value="1975">1975</option><option value="1974">1974</option><option value="1973">1973</option><option value="1972">1972</option><option value="1971">1971</option><option value="1970">1970</option><option value="1969">1969</option><option value="1968">1968</option><option value="1967">1967</option><option value="1966">1966</option><option value="1965">1965</option><option value="1964">1964</option><option value="1963">1963</option><option value="1962">1962</option><option value="1961">1961</option><option value="1960">1960</option><option value="1959">1959</option><option value="1958">1958</option><option value="1957">1957</option><option value="1956">1956</option><option value="1955">1955</option><option value="1954">1954</option><option value="1953">1953</option><option value="1952">1952</option><option value="1951">1951</option><option value="1950">1950</option><option value="1949">1949</option><option value="1948">1948</option><option value="1947">1947</option><option value="1946">1946</option><option value="1945">1945</option><option value="1944">1944</option><option value="1943">1943</option><option value="1942">1942</option><option value="1941">1941</option><option value="1940">1940</option><option value="1939">1939</option><option value="1938">1938</option><option value="1937">1937</option><option value="1936">1936</option><option value="1935">1935</option><option value="1934">1934</option><option value="1933">1933</option><option value="1932">1932</option><option value="1931">1931</option><option value="1930">1930</option><option value="1929">1929</option><option value="1928">1928</option><option value="1927">1927</option><option value="1926">1926</option><option value="1925">1925</option><option value="1924">1924</option><option value="1923">1923</option><option value="1922">1922</option><option value="1921">1921</option><option value="1920">1920</option></select>
                        </div>
                    </div>
                  </div>
                </div> -->
                <div class="lCol tCell">
                  <div :class="['fieldInner', errors.has('phone_cn') == true ? 'aa' : '']">
                    <label>手提電話<sup>*</sup></label>
                    <div class="inputFieldGroup">
                      <label>+852</label>
                    </div>
                    <div class="inputFieldGroup">
                      <div :class="['inputField', errors.has('phone_cn') == true ? 'hasError' : '']">
                        <input type="number"
                               name="phone_cn"
                               v-validate="'required'"
                               v-model="formData.phone"
                               placeholder="手提電話">
                      </div>
                      <div class="errorField"
                           v-show="errors.has('phone_cn')">{{ errors.first('phone_cn') }}</div>
                    </div>
                  </div>
                </div>
                <div class="sepCol tCell">&nbsp;</div>
                <div class="rCol tCell">
                  <!-- <div class="fieldInner">
                    <div :class="['inputFieldGroup', errors.has('sex_cn') == true ? 'hasError' : '']">
                      <label>性別<sup>*</sup></label>
                        <div class="radioField" >
                          <div class="radioOption"><input type="radio" id="male" name="sex_cn" v-validate="'required'" v-model="formData.sex" :value="1" @click="radioCl($event)"> <label for="male">男性</label></div>
                          <div class="radioOption"><input type="radio" id="female" name="sex_cn" v-validate="'required'" v-model="formData.sex" :value="0" @click="radioCl($event)"> <label for="female">女性</label></div>
                        </div>
                        <div class="errorField" v-show="errors.has('sex_cn')">{{ errors.first('sex_cn') }}</div>
                    </div>   
                  </div> -->
                  <div class="fieldInner">
                    <div :class="['inputFieldGroup', errors.has('email') == true ? 'hasError' : '']">
                      <label>電郵</label>
                      <div :class="['inputField', errors.has('email') == true ? 'hasError' : '']">
                        <input type="text"
                               name="email"
                               v-validate="'email_cn'"
                               v-model="formData.email"
                               placeholder="電郵">
                      </div>
                      <div class="errorField"
                           v-show="errors.has('email')">{{ errors.first('email') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="formRow row04">
            <div class="tWrap">
                <div class="tRow">
                  <div class="lCol tCell">
                    <div class="fieldInner">
                      <div class="inputFieldGroup">
                        <label>選擇語言</label>
                        <div class="inputField selection">
                          <select name="language" v-model="formData.language" @focus="selectFn($event)" @blur="selectBr($event)">
                            <option selected value="英文">英文</option>
                            <option value="繁體中文">繁體中文</option>
                            <option value="簡體中文">簡體中文</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="sepCol tCell">&nbsp;</div>
                  <div class="rCol tCell">
                    <div class="fieldInner">
                      <div :class="['inputFieldGroup', errors.has('email') == true ? 'hasError' : '']">
                        <label>電郵</label>
                        <div :class="['inputField', errors.has('email') == true ? 'hasError' : '']">
                          <input type="text" name="email" v-validate="'email_cn'" v-model="formData.email" placeholder="電郵">
                        </div>
                        <div class="errorField" v-show="errors.has('email')">{{ errors.first('email') }}</div>
                      </div>
                    </div>
                    <div class="fieldInner">
                        <div class="inputFieldGroup" id="input_group_phone_no">
                            <label>Other contact number</label>
                            <div class="inputField"><input type="number" name="phone_no" id="phone_no" placeholder="Other contact number (if any)"></div>
                            <div class="errorField" id="error_phone_no"></div>
                        </div>
                    </div>
                  </div>
                </div>
              </div>
          </div> -->
          <div class="formRow row09">
            <div class="tWrap">
              <div class="tRow">
                <div class="lCol tCell">
                  <div class="fieldInner">
                    <div :class="['inputFieldGroup', errors.has('Yn_cn') == true ? 'hasError' : '']"
                         id="input_group_current_model">
                      <label>你是否 <font class="audiTxtTypeNormal">Audi</font> 車主?<sup>*</sup></label>
                      <div :class="['inputField', 'selection', errors.has('Yn_cn') == true ? 'hasError' : '']">
                        <select name="Yn_cn"
                                v-model="Yn"
                                v-validate="'required'"
                                @change="selectChange($event)"
                                @focus="selectFn($event)"
                                @blur="selectBr($event)">
                          <option selected
                                  disabled
                                  value="">你是否 Audi 車主?</option>
                          <option value="yes">是</option>
                          <option value="no">否</option>
                        </select>
                      </div>
                      <div class="errorField"
                           v-show="errors.has('Yn_cn')">{{ errors.first('Yn_cn') }}</div>
                    </div>
                  </div>
                </div>
                <div class="sepCol tCell">&nbsp;</div>
                <div class="rCol tCell">
                  <div :class="['fieldInner', 'no', this.Yn == 'yes' ? 'yes' : '']"
                       :disabled="this.Yn == 'yes' ? true : false">
                    <div :class="['inputFieldGroup', errors.has('audiCarModel_cn') == true ? 'hasError' : '']"
                         id="input_group_current_model">
                      <label>現有 <font class="audiTxtTypeNormal">Audi</font> 車款型號<sup>*</sup></label>
                      <div :class="['inputField','selection', errors.has('audiCarModel_cn') == true ? 'hasError' : '']">
                        <select name="audiCarModel_cn"
                                v-validate="this.Yn == 'yes' ? 'required' : ''"
                                v-model="formData.audiCarModel"
                                @focus="selectFn($event)"
                                @blur="selectBr($event)">
                          <option selected
                                  disabled
                                  value="">請選擇 Audi 車款型號</option>
                          <optgroup label="A1">
                            <option value="A1 Hatchback">A1 Hatchback</option>
                            <option value="A1 Sportback">A1 Sportback</option>
                            <option value="S1 Sportback">S1 Sportback</option>
                          </optgroup>
                          <optgroup label="A3">
                            <option value="A3 Hatchback">A3 Hatchback</option>
                            <option value="A3 Sportback">A3 Sportback</option>
                            <option value="A3 Sedan">A3 Sedan</option>
                            <option value="S3 Sportback">S3 Sportback</option>
                            <option value="S3 Sedan">S3 Sedan</option>
                            <option value="RS 3 Sedan">RS 3 Sedan</option>
                            <option value="RS 3 Sportback">RS 3 Sportback</option>
                          </optgroup>
                          <optgroup label="A4">
                            <option value="A4 Saloon">A4 Saloon</option>
                            <option value="A4 Avant">A4 Avant</option>
                            <option value="S4 Saloon">S4 Saloon</option>
                            <option value="RS 4 Sedan">RS 4 Sedan</option>
                            <option value="S4 Avant">S4 Avant</option>
                            <option value="RS 4 Avant">RS 4 Avant</option>
                            <option value="RS 4 Cabriolet">RS 4 Cabriolet</option>
                          </optgroup>
                          <optgroup label="A5">
                            <option value="A5 Coupé">A5 Coupé</option>
                            <option value="A5 Sportback">A5 Sportback</option>
                            <option value="A5 Cabriolet">A5 Cabriolet</option>
                            <option value="S5 Coupé">S5 Coupé</option>
                            <option value="S5 Sportback">S5 Sportback</option>
                            <option value="S5 Cabriolet">S5 Cabriolet</option>
                            <option value="RS 5 Coupé">RS 5 Coupé</option>
                            <option value="RS 5 Sportback">RS 5 Sportback</option>
                            <option value="RS 5 Cabriolet">RS 5 Cabriolet</option>
                          </optgroup>
                          <optgroup label="A6">
                            <option value="A6 Saloon">A6 Saloon</option>
                            <option value="A6 Avant">A6 Avant</option>
                            <option value="S6 Saloon">S6 Saloon</option>
                            <option value="S6 Avant">S6 Avant</option>
                            <option value="RS 6 Avant">RS 6 Avant</option>
                          </optgroup>
                          <optgroup label="A7">
                            <option value="A7 Sportback">A7 Sportback</option>
                            <option value="S7 Sportback">S7 Sportback</option>
                            <option value="RS 7 Sportback">RS 7 Sportback</option>
                          </optgroup>
                          <optgroup label="A8">
                            <option value="A8 L">A8 L</option>
                            <option value="S8">S8</option>
                          </optgroup>
                          <optgroup label="Q2">
                            <option value="Q2">Q2</option>
                            <option value="SQ2">SQ2</option>
                          </optgroup>
                          <optgroup label="Q3">
                            <option value="Q3">Q3</option>
                            <option value="Q3 Sportback">Q3 Sportback</option>
                            <option value="RS Q3">RS Q3</option>
                            <option value="RS Q3 Sportback">RS Q3 Sportback</option>
                          </optgroup>
                          <optgroup label="Q5">
                            <option value="Q5">Q5</option>
                            <option value="SQ5">SQ5</option>
                          </optgroup>
                          <optgroup label="Q7">
                            <option value="Q7">Q7</option>
                          </optgroup>
                          <optgroup label="Q8">
                            <option value="Q8">Q8</option>
                            <option value="RS Q8">RS Q8</option>
                          </optgroup>
                          <optgroup label="TT">
                            <option value="TT Coupé">TT Coupé</option>
                            <option value="TTS Coupé">TTS Coupé</option>
                            <option value="TTS Roadster">TTS Roadster</option>
                            <option value="TT RS Coupé">TT RS Coupé</option>
                            <option value="TT RS Roadster">TT RS Roadster</option>
                          </optgroup>
                          <optgroup label="R8">
                            <option value="R8 Coupé">R8 Coupé</option>
                            <option value="R8 Spyder">R8 Spyder</option>
                          </optgroup>
                          <optgroup label="e-tron">
                            <option value="e-tron">e-tron</option>
                            <option value="e-tron Sportback">e-tron Sportback</option>
                          </optgroup>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                      <div class="errorField"
                           v-show="errors.has('audiCarModel_cn')">{{ errors.first('audiCarModel_cn') }}</div>
                    </div>
                  </div>
                  <div :class="['fieldInner', 'no', this.Yn == 'no' ? 'yes' : '']">
                    <div :class="['inputFieldGroup', errors.has('carBrand_cn') == true ? 'hasError' : '']">
                      <label>非車主/請選擇車廠 <sup>*</sup></label>
                      <div :class="['inputField', 'selection',  errors.has('carBrand_cn') == true ? 'hasError' : '']"
                           @focus="selectFn($event)"
                           @blur="selectBr($event)">
                        <select name="carBrand_cn"
                                v-model="formData.carBrand"
                                v-validate="this.Yn == 'no' ? 'required' : ''">
                          <option selected
                                  disabled
                                  value="">非車主/請選擇車廠</option>
                          <option value="非車主">非車主</option>
                          <option value="Alfa Romeo">Alfa Romeo</option>
                          <option value="Aston Martin ">Aston Martin </option>
                          <option value="Bentley ">Bentley</option>
                          <option value="Bmw">Bmw</option>
                          <option value="Citroen">Citroen</option>
                          <option value="Daihatsu">Daihatsu</option>
                          <option value="Ferrari">Ferrari</option>
                          <option value="Fiat">Fiat</option>
                          <option value="Ford">Ford</option>
                          <option value="Honda">Honda</option>
                          <option value="Hyundai">Hyundai</option>
                          <option value="Jaguar">Jaguar</option>
                          <option value="Kia">Kia</option>
                          <option value="Lamborghini">Lamborghini</option>
                          <option value="Land Rover">Land Rover</option>
                          <option value="Lexus">Lexus</option>
                          <option value="Maserati">Maserati</option>
                          <option value="Maybach">Maybach</option>
                          <option value="Mazda">Mazda</option>
                          <option value="Mercedes-Benz">Mercedes-Benz</option>
                          <option value="Mini">Mini</option>
                          <option value="Mitsubishi">Mitsubishi</option>
                          <option value="Nissan">Nissan</option>
                          <option value="Opel">Opel</option>
                          <option value="Pagani">Pagani</option>
                          <option value="Peugeot">Peugeot</option>
                          <option value="Porsche">Porsche</option>
                          <option value="Renault">Renault</option>
                          <option value="Rolls Royce ">Rolls Royce </option>
                          <option value="Saab">Saab</option>
                          <option value="Smart">Smart</option>
                          <option value="Ssangyong">Ssangyong</option>
                          <option value="Subaru">Subaru</option>
                          <option value="Suzuki">Suzuki</option>
                          <option value="Toyota">Toyota</option>
                          <option value="Volkswagen">Volkswagen</option>
                          <option value="Volvo">Volvo</option>
                          <option value="Others">Others</option>
                        </select>
                      </div>
                      <div class="errorField"
                           v-show="errors.has('carBrand_cn')">{{ errors.first('carBrand_cn') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="agreeRow">
            <p>錦龍有限公司 及錦龍汽車集團(下稱本公司) 有意使用您的個人資料 (包括您的名稱聯絡資料及其他資料等)以直接促銷我們的服務和商品。
              <br />
              由本公司持有的個人資料將予以保密，但本公司可能會在合理的情況下使用或處理您的個人資料，或把您的個人 資料披露或轉移予本公司的相關機構、第三方金融機構、承保人、市場調查服務供應商、市場活動策劃公司及其他服務供應商， 以作直接促銷之用，包括但不限於:
              <br />
              (一) 發送新產品，汽車配件和即將推出的服務的通知;
              <br />
              (二) 提供企業通訊和更新;
              <br />
              (三) 發送 維修保養、續牌及續保等提示;
              <br />
              (四) 發送活動邀請和特別促銷活動的通知;及
              <br />
              (五) 進行市場、服務或產品分析或研究、發展或 改善汽車服務或有關產品。</p>
            <p>有關修改或删除已提供的個人資料，請聯絡本公司客戶服務部 <a href="tel:+852 2448 2768">+852 2448 2768</a> 或電郵至 <a href="mailto:unsubscribe@kamlung.com">unsubscribe@kamlung.com</a>。</p>
            <div class="agreeOptionRow">
              <div class="tWrap">
                <div class="tRow">
                  <div class="checkCol tCell"><input type="checkbox"
                           name="Privacy1_cn"
                           id="Privacy1_cn"
                           v-validate="'Privacy1_cn_c'"
                           :value="formData.Privacy1"
                           checked
                           v-model="formData.Privacy1"
                           hidden=""
                           @change="checkboxCl($event, 'Privacy1')"> <label for="Privacy1_cn"
                           :class="[formData.Privacy1 == true ? 'active' : '']"></label></div>
                  <div class="sepCol tCell"></div>
                  <div class="txtCol tCell">
                    <p>本人已詳細閱讀並同意上述 <a href="javascript:;"
                         @click="showPopup"
                         class="btnTnc">隱私政策及聲明</a>，包括個人資料的收集和處理。</p>
                  </div>
                </div>
              </div>
              <div class="formSection">
                <div class="inputFieldGroup">
                  <div class="errorField"
                       v-show="errors.has('Privacy1_cn')">{{ errors.first('Privacy1_cn') }}</div>
                </div>
              </div>
            </div>
            <div class="agreeOptionRow">
              <div class="tWrap">
                <div class="tRow">
                  <div class="checkCol tCell">
                    <input type="checkbox"
                           name="Privacy2_cn"
                           id="Privacy2_cn"
                           v-validate="'Privacy2_cn_c'"
                           :value="formData.Privacy2"
                           checked
                           v-model="formData.Privacy2"
                           hidden=""
                           @change="checkboxCl($event)">
                    <label for="Privacy2_cn"
                           :class="[formData.Privacy2 == true ? 'active' : '']"></label>
                  </div>
                  <div class="sepCol tCell"></div>
                  <div class="txtCol tCell">
                    <p>本人聲明就本人所知所信，在此表格內所填報的各項資料均屬真確。如有任何爭議，本人亦明白錦龍有限公司及錦龍汽車集團將保留最終決定權。</p>
                  </div>
                </div>
              </div>

              <div class="formSection">
                <div class="inputFieldGroup">
                  <div class="errorField"
                       v-show="errors.has('Privacy2_cn')">{{ errors.first('Privacy2_cn') }}</div>
                </div>
              </div>
            </div>
            <div class="agreeOptionRow">
              <div class="tWrap">
                <div class="tRow">
                  <div class="checkCol tCell">
                    <input type="checkbox"
                           name="receive_klm_msg"
                           id="receive_klm_msg"
                           :value="formData.Privacy3"
                           checked
                           v-model="formData.Privacy3"
                           hidden=""
                           @change="checkboxCl($event, 'Privacy3')">
                    <label for="receive_klm_msg"
                           :class="[formData.Privacy3 == true ? 'active' : '']"></label>
                  </div>
                  <div class="sepCol tCell"></div>
                  <div class="txtCol tCell">
                    <p>本人不希望收到錦龍有限公司及錦龍汽車集團的直銷宣傳推廣及通訊。</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="ctaRow">
            <van-button class="primary"
                        :loading="load"
                        native-type="button"
                        @click="onSubmit()">提交</van-button>
          </div>
        </div>
      </form>
    </div>

    <div class="gallery-wrapper">
      <h3><strong>相片集</strong></h3>
      <div class="ul">
        <div class="li"
             v-for="(item, index) in gallerySportback"
             :style="{'background-image': 'url(' + item.small + ')'}"
             :key="index">
          <img preview="0"
               preview-text=""
               class="animate__animated animate__fadeIn"
               :src="item.small"
               alt="">
          <!-- <img :src="item.small" class="animate__animated animate__fadeIn hidden-xs"> -->
        </div>
      </div>
    </div>

    <div class="gallery-wrapper">
      <div class="ul">
        <div class="li"
             v-for="(item, index) in gallerySedan"
             :style="{'background-image': 'url(' + item.small + ')'}"
             :key="index">
          <img preview="1"
               preview-text=""
               class="animate__animated animate__fadeIn"
               :src="item.small"
               alt="">
          <!-- <img :src="item.small" class="animate__animated animate__fadeIn hidden-xs"> -->
        </div>
      </div>
    </div>

    <footer id="footer">
      <div class="inner">
        <h3>奧迪旗艦陳列室及售後服務中心</h3>
        <div class="locationListing">
          <ul>
            <li>
              <dl>
                <dt>奧迪旗艦陳列室</dt>
                <dd>香港太古城太古灣道 12 號地下</dd>
                <dd>營業時間：<br>
                  <font>週一至週日 09:00 至 20:00 </font>
                  <font>（包括公眾假期）</font>
                </dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>觀塘售後服務中心</dt>
                <dd>觀塘海濱道 175 號國際工業大廈地下</dd>
                <dd>營業時間：<br>
                  <font>週一至週五 08:00至 19:00；</font>
                  <font>週六 08:30 至 18:00；</font>
                  <font>週日及公眾假期：休息</font>
                </dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>柴灣售後服務中心</dt>
                <dd>柴灣永泰道 70 號柴灣工業城第二期地下 2 號室</dd>
                <dd>營業時間：<br>
                  <font>週一至週五 08:00 至 19:00；</font>
                  <font>週六 08:30 至 18:00；</font>
                  <font>週日及公眾假期：休息</font>
                </dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>荃灣售後服務中心</dt>
                <dd>荃灣柴灣角街 53 至 57 號地下</dd>
                <dd>營業時間：<br>
                  <font>週一至週五 08:00 至 19:00；</font>
                  <font>週六 08:30 至 18:00；</font>
                  <font>週日及公眾假期：休息</font>
                </dd>
              </dl>
            </li>
          </ul>
        </div>
        <div class="otherInfoListing">
          <ul>
            <li>
              <dl>
                <dt>聯絡銷售團隊</dt>
                <dd>熱線：2291 0000</dd>
                <dd>電郵：<a href="mailto:enquiry@audi-klm.com.hk">enquiry@audi-klm.com.hk</a></dd>
              </dl>
            </li>
            <li>
              <dl>
                <dt>聯絡售後服務團隊</dt>
                <dd>熱線：3465 0000</dd>
                <dd>電郵：<a href="mailto:customer.relations@audi-klm.com.hk">customer.relations@audi-klm.com.hk</a></dd>
              </dl>
            </li>
          </ul>
        </div>
        <div class="socialListing">
          <ul>
            <li><a href="https://www.facebook.com/AudiHK/"
                 target="_blank"><img src="../../images/img-facebook.jpg"></a></li>
            <li><a href="https://www.instagram.com/audihk/"
                 target="_blank"><img src="../../images/img-instagram.jpg"></a></li>
            <li><a href="https://www.youtube.com/user/audihkofficial"
                 target="_blank"><img src="../../images/img-youtube.jpg"></a></li>
          </ul>
        </div>
      </div>
    </footer>
    <div class="chatbox-float">
      <div :class="['popup-icon-box']">
        <a :class="['whatsapp-icon', popupOnoff == true ? 'cut' : '']"
           @click="appSee('whatsapp')"></a>
        <a :class="['facebook-icon', popupOnoff == true ? 'cut' : '']"
           @click="appSee('facebook')"></a>
      </div>
      <button class="popup-icon-btn"
              native-type="button"
              @click="changeOnoff()"></button>
    </div>
    <van-popup class="van-popup1"
               closeable
               close-icon="close"
               v-model="show">
      <PrivacyPolicyCn />
    </van-popup>
    <van-popup class="van-popup2"
               closeable
               close-icon="close"
               v-model="showpdf">
      <PDF :value="pdfdow" />
    </van-popup>

    <!-- <van-popup class="van-popup-tips" closeable close-icon="close" v-model="showTips">
      <p>根據 <span class="audiTxtExtendedNormal">2021</span> 最新汽車首次登記稅，車價可能會作調整。</p>
      <br/>
      <p class="audiTxtExtendedNormal">Car prices may be adjusted due to the latest 2021 Motor Vehicle First Registration Tax rates.</p>
    </van-popup> -->
  </div>
</template>

<script>
import Swiper from "swiper"
import { reqAddCustomer } from '../../untils/api.js';
import { Toast, Button, Popup } from 'vant'
import PrivacyPolicyCn from './PrivacyPolicyCn.vue';
import PDF from '../../untils/pdf/pdf.vue';


let arrss = new Array()
arrss[0] = { name: "tom" }
arrss[1] = { name: "sss" }
console.log('arrss', arrss)

export default {
  name: "Home",
  inject: ['reload'],
  data () {
    return {
      selDate: new Date('2021-05-20'),
      selDate_Yn: false,
      maxDate: new Date('2021-06-30'),
      minDate: new Date('2021-05-20'),

      timerCon: '',
      popupOnoff: false,
      pdfdow: {},
      show: false,
      showpdf: false,
      showTips: true, //开始提示文字
      load: false,
      url: this.$store.state.baseURL,
      time: {
        d: '',
        h: '',
        m: '',
        s: '',
      },
      el: '#conbox',
      Yn: '',
      formData: {
        activitiCode: 'S3',
        cch: '',
        surname: '',
        name: '',
        birthYear: '',
        birthMonth: '',
        birthDay: '',
        sex: '',
        phone: '',
        email: '',
        isAudi: '',
        carBrand: '',
        audiCarModel: '',
        language: '英文',

        selDate: '', //预约日期
        selTime: '', //预约时段

        extend1: '',
        extend2: '',

        Privacy1: false,
        Privacy2: false,
        Privacy3: false,
      },
      cardSlideListBottom: [
        { title: '運動懸掛連減震控制系統', text: '', img: require("../../picture/o1.jpg"), imgxs: require("../../picture/o1.jpg") },
        { title: 'Matrix LED 頭燈', text: '', img: require("../../picture/o2.jpg"), imgxs: require("../../picture/o2.jpg") },
        { title: '全數碼化儀錶板', text: '', img: require("../../picture/o3.jpg"), imgxs: require("../../picture/o3.jpg") },
        { title: '全景天幕天窗', text: '', img: require("../../picture/o4.jpg"), imgxs: require("../../picture/o4.jpg") },
        { title: '四出排氣系統', text: '', img: require("../../picture/o5.jpg"), imgxs: require("../../picture/o5.jpg") },
        { title: '亮黑個性配備', text: '', img: require("../../picture/o6.jpg"), imgxs: require("../../picture/o6.jpg") },
        { title: 'Bang & Olufsen 3D 環迴音響', text: '', img: require("../../picture/o7.jpg"), imgxs: require("../../picture/o7.jpg") },
        { title: '車廂氣氛燈', text: '', img: require("../../picture/o8.jpg"), imgxs: require("../../picture/o8.jpg") },
      ],
      carsQList: [
        { title: 'Audi Sport 19 吋五輻式輪圈', text: '', dow: 'http://q7.hk-audi.com:9197/hkq7/file/S3 SPORTBACK QUATTRO spec sheet_MY21.pdf', img: require("../../picture/o9.jpg"), model: '' },
        { title: '前排真皮運動化座椅', text: '', dow: 'http://q7.hk-audi.com:9197/hkq7/file/S3 SEDAN QUATTRO spec sheet_MY21.pdf', img: require("../../picture/o10.jpg"), model: '' },
      ],
      cardSlideListPrice: [
        { title: 'S3 Sportback', text1: '基本型號 HK$499,000 起', text2: 'Vorsprung 特別版 HK$529,000 起', img: require("../../picture/o1.jpg"), imgxs: require("../../picture/o1.jpg") },
        { title: 'S3 Sedan', text1: '基本型號 HK$529,000 起', text2: 'Vorsprung 特別版 HK$559,000 起', img: require("../../picture/o2.jpg"), imgxs: require("../../picture/o2.jpg") },
      ],
      // carsPriceList: [
      //   {title: '陳列車優惠價 : HK$359,900', text: '原價 : HK$379,900', href: 'https://www.audi.com.hk/hk/web/en/models/q3/q3.html', img: require("../../picture/p-Q3-v1.jpg"), model: ''},
      //   {title: '陳列車優惠價 : HK$968,000', text: '原價 : HK$1,085,000', href: 'https://www.audi.com.hk/hk/web/en/models/q8/q8.html', img: require("../../picture/p-Q8-v1.jpg"), model: ''},
      //   {title: '陳列車優惠價 : HK$599,000', text: '原價 : HK$698,000', href: 'https://www.audi.com.hk/hk/web/en/models/a7/the-new-a7-sportback.html', img: require("../../picture/p-A7-v1.jpg"), model: ''},
      //   {title: '優惠高達 HK$37,000*', text: '', href: 'https://www.audi.com.hk/hk/web/en/models/q5/the-new-q5.html', img: require("../../picture/p-Q5-v1.jpg"), model: ''},
      //   {title: '優惠高達 HK$37,000*', text: '', href: 'https://www.audi.com.hk/hk/web/en/models/a3/a3-sportback.html', img: require("../../picture/p-A3-v1.jpg"), model: ''},
      //   {title: '優惠高達 HK$37,000*', text: '', href: 'https://www.audi.com.hk/hk/web/en/models/a5/a5-sportback-2021.html', img: require("../../picture/p-A5-v1.jpg"), model: ''},
      // ],
      gallerySportback: [
        {
          small: require("../../picture/Sportback-Gallery/Sportback-Gallery-image-1.jpg"),
          large: require("../../picture/Sportback-Gallery/large/Sportback Gallery-image 1.jpg")
        },
        {
          small: require("../../picture/Sportback-Gallery/Sportback-Gallery-image-2.jpg"),
          large: require("../../picture/Sportback-Gallery/large/Sportback Gallery-image 2.jpg")
        },
        {
          small: require("../../picture/Sportback-Gallery/Sportback-Gallery-image-3.jpg"),
          large: require("../../picture/Sportback-Gallery/large/Sportback Gallery-image 3.jpg")
        },
        {
          small: require("../../picture/Sportback-Gallery/Sportback-Gallery-image-4.jpg"),
          large: require("../../picture/Sportback-Gallery/large/Sportback Gallery-image 4.jpg")
        },
        {
          small: require("../../picture/Sportback-Gallery/Sportback-Gallery-image-5.jpg"),
          large: require("../../picture/Sportback-Gallery/large/Sportback Gallery-image 5.jpg")
        }
      ],
      gallerySedan: [
        {
          small: require("../../picture/Sedan-Gallery/Sedan-Gallery-image-1.jpg"),
          large: this.$store.state.baseURL + '/s3-img/S3 Sedan Gallery/Sedan Gallery-image 1.jpg'
        },
        {
          small: require("../../picture/Sedan-Gallery/Sedan-Gallery-image-2.jpg"),
          large: this.$store.state.baseURL + '/s3-img/S3 Sedan Gallery/Sedan Gallery-image 2.jpg'
        },
        {
          small: require("../../picture/Sedan-Gallery/Sedan-Gallery-image-3.jpg"),
          large: this.$store.state.baseURL + '/s3-img/S3 Sedan Gallery/Sedan Gallery-image 3.jpg'
        },
        {
          small: require("../../picture/Sedan-Gallery/Sedan-Gallery-image-4.jpg"),
          large: this.$store.state.baseURL + '/s3-img/S3 Sedan Gallery/Sedan Gallery-image 4.jpg'
        },
        {
          small: require("../../picture/Sedan-Gallery/Sedan-Gallery-image-5.jpg"),
          large: this.$store.state.baseURL + '/s3-img/S3 Sedan Gallery/Sedan Gallery-image 5.jpg'
        }
      ],
      carsList: [
        // {title: 'RS 4 Avant', text: '全新高性能旅行車 Audi RS 4 Avant quattro ，完美演示如何以澎湃的運動性能融合日常使用。', href: 'https://www.audi.com.hk/hk/web/en/models/a4/rs-4-avant-2021.html', img: require("../../picture/e-RS-4-Avant.jpg"), model: 'RS 4'},
        // {title: 'RS 5 Sportback', text: 'Audi RS 5 Sportback 擁有硬朗的車身輪廓，配以鮮明的車側肌肉線條，突顯了其運動型外觀。', href: 'https://www.audi.com.hk/hk/web/en/models/a5/rs-5-sportback-2021.html', img: require("../../picture/e-RS-5-Sportback.jpg"), model: 'RS 5'},
        // {title: 'RS 6 Avant', text: '融合跑車的高性能表現與舒適旅行車的概念，可讓您在競速賽道與日常生活中自由穿梭。 無論是往返商務會議，或是接載家庭樂，其設計不失高性能跑車的動感，同時具備日常使用的實用性。', href: 'https://www.audi.com.hk/hk/web/en/models/a6/rs-6-avant.html', img: require("../../picture/e-RS-6-Avant.jpg"), model: 'RS 6 Avant'},
        // {title: 'RS 7 Sportback', text: '追求極致性能的狂野心? 抑或風度翩翩的姿態? 當您駕馭 Audi RS 7 Sportback 便兩者皆可兼得，請即體驗其創新的動感設計與百年賽道工藝的魅力！ ', href: 'https://www.audi.com.hk/hk/web/en/models/a7/rs-7-sportback-2021.html', img: require("../../picture/e-RS-7-Sportback.jpg"), model: 'RS 7 Sportback'},
        // {title: 'RS Q3 Sportback', text: '經典 RS 專屬設計元素令 RS Q3 Sportback 整體車身更具運動感， 搭載 2.5 公升 TFSI 直列 5 缸渦輪增壓引擎 ，輸出高達 400 匹的澎湃馬力。  ', href: 'https://www.audi.com.hk/hk/web/en/models/q3/rs-q3-sportback-2021.html', img: require("../../picture/e-RS-Q3-Sportback.jpg"), model: 'RS Q3 Sportback'},
        // {title: 'RS Q3', text: '全新高性能 Audi RS Q3 SUV 擁有動感的外觀，同時具備日常使用的實用性。運動化的配置包括 quattro 四輪驅動及獲獎無數的 2.5 公升 TFSI 直列 5 缸渦輪增壓引擎 ，只待您親自感受令人熱血澎湃的激情聲浪。', href: 'https://www.audi.com.hk/hk/web/en/models/q3/rs-q3-2021.html', img: require("../../picture/e-RS-Q3.jpg"), model: 'RS Q3'},
        // {title: 'RS Q8', text: 'Audi Sport 史上最強勁、最高性能的 SUV 轎跑車， 超凡的配備可輸出 600  匹馬力。 除了出色的 RS 性能外，這款令人印象深刻的跑車還能夠在駕駛體驗和設計上做出非凡的轉變，為您帶來意想不到的驚喜。', href: 'https://www.audi.com.hk/hk/web/en/models/q8/rs-q8.html', img: require("../../picture/e-RS-Q8.jpg"), model: 'RS Q8'},
        // {title: 'TT RS Coupé', text: '從無可匹敵的動力傳輸，以至俐落的設計美感， Audi TT RS Coupé 秉承賽車基因，為了強調最頂端的駕馭體驗而生。這款旗艦級跑車同時具備反應迅捷的操控感及穩定性，契合駕駛者的完美座駕，為您帶來無與倫比的乘駕體驗 。', href: 'https://www.audi.com.hk/hk/web/en/models/tt/tt-rs-coupe.html', img: require("../../picture/e-TT-RS.jpg"), model: 'TT RS Coupé'},
        // {title: 'Audi Q5 Design Line', text: '震撼價 $499,880 發售 <br/>五年原廠全車保用 <br/>五項升級配備：<br/>19 吋灰底電鍍五輻式合金輪圈 , LED 頭燈及尾動態指揮燈 , 前座跑車座椅及可前後及多角度調節後座 , 12.3 吋 Audi Virtual cockpit 數碼化儀錶及 MMI® 導航系統 , 支援智能電話介面Apple CarPlay 及Android Auto <br/> 五折優惠奧迪精品（凡預約試車即可享有 ) <br/> 同場提供即場二手車評估，奧迪及豪華品牌車主可享特高收車', href: 'https://www.audi.com.hk/hk/web/en/models/q5/the-new-q5.html', img: require("../../picture/i-Q5-v1.jpg"), model: 'Q5'},
        // {title: 'Audi A3 Sportback quattro S-line', text: '只售 $325,800 起 <br/>三年專屬升級回購計劃，尊享七折回購保證 <br/>五年原廠全面保用 <br/>配備 S-line 包圍套件 <br/>設有轉波撥片的真皮多功能軚盤', href: 'http://a3.hk-audi.com/tc/', img: require("../../picture/i-A3-v1.jpg"), model: 'A3'},
      ],

      swiperSlides: [
        {
          id: 0,
          pcImgUrl: require("../../picture/banner.jpg"),
          phoneImgUrl: require("../../picture/banner_mobile.jpg"),
          title: ""
        },
        // {
        //   id: 0,
        //   pcImgUrl: require("../../picture/banner1_cn.jpg"),
        //   phoneImgUrl: require("../../picture/banner1_mobile_cn.jpg"),
        //   title: ""
        // },
      ]
    }
  },
  components: {
    PrivacyPolicyCn,
    PDF
  },
  mounted () {
    // let that = this
    // let thatDate = new Date(new Date().getTime()+24*60*60*1000*2)
    // let year = thatDate.getFullYear(); // 年
    // let month = thatDate.getMonth() + 1; // 月
    // let day = thatDate.getDate(); // 日
    // that.date = new Date(year + '/' + month + '/' + day)
    // console.log('asdsadasdsadsa', new Date(year + '/' + month + '/' + day))

    // console.log('max', this.maxDate)
    // console.log('min', this.minDate)
    let that = this

    that.carsList.forEach((v, i) => {
      that.carsList[i].arr = v.text.split("<br/>")
      if (i == 0) {
        that.carsList[i].arr.forEach((v2, i2) => {
          if (i2 == 3) {
            // console.log('v2', v2)
            // console.log('i2', i2)
            let arrs = []
            arrs = v2.split(" , ")
            that.carsList[i].arr[3] = arrs
          }
        })
      }
      // console.log('that.carsList[i]', that.carsList[i].arr[3].constructor == Array)
      // console.log('that.carsList[i]', that.carsList[i])
    })
    // that.carsQList.forEach((v, i) => {
    //   that.carsQList[i].arr = v.text.split("<br/>")
    // })

    // that.cardSlideList.forEach((v, i) => {
    //   that.cardSlideList[i].arr = v.text.split("<br/>")
    // })

    setTimeout(() => {
      this.initSwiper();
      // console.log(this.$store.state.baseURL)
    }, 0);
    // this.$set(this.formData, "cch", 1);
  },
  created () {
    this.countTime()
  },
  methods: {
    //按钮定时器 10秒后没有操作收回
    timer () {
      let that = this
      that.timerCon = setTimeout(() => {
        that.popupOnoff = false
      }, 10000)
    },
    appSee (e) {
      let that = this
      let url = ''

      clearInterval(that.timerCon)

      if (e == 'whatsapp') {
        url = 'https://api.whatsapp.com/send?phone=%2B85270728919&text=%E6%82%A8%E5%A5%BD%EF%BC%8C%E6%88%91%E6%83%B3%E4%BA%86%E8%A7%A3%E5%85%A8%E6%96%B0%E7%9A%84%20Audi%20S3%20%E8%A9%B3%E6%83%85'
      } else if (e == 'facebook') {
        url = 'https://m.me/AudiHK'
      }

      that.timer()
      window.open(url, "_blank")
    },
    changeOnoff () {
      let that = this
      that.popupOnoff = !that.popupOnoff
      if (that.popupOnoff == true) {
        that.timer()
      }
    },
    //是否显示日期
    focusData () {
      this.selDate_Yn = true
    },
    closeData () {
      this.selDate_Yn = false
    },
    //日期选择
    changeDate (date) {
      let that = this
      let year = date.getFullYear(); // 年
      let month = date.getMonth() + 1; // 月
      let day = date.getDate(); // 日

      console.log('datedate', year + '/' + month + '/' + day)
      that.formData.selDate = year + '-' + month + '-' + day
      that.closeData()
    },
    allowedDates (date) {
      let thisDate = new Date();
      let year = thisDate.getFullYear(); // 年
      let month = thisDate.getMonth() + 1; // 月
      let day = thisDate.getDate(); // 日

      let thisTime = new Date(year + '/' + month + '/' + day)
      let updataTime = new Date((date.getFullYear() + '/' + (date.getMonth() + 1) + '/' + date.getDate()))
      // console.log('thisTime', year + '/' + month + '/' + day)
      // console.log('thisTime', thisTime.getTime()+24*60*60*1000*2)
      // console.log('updataTime', updataTime.getTime())
      // console.log('updataTime', date.getFullYear() + '/' + (date.getMonth()+1) + '/' + date.getDate())
      // console.log('thisYMD', thisYMD)
      // console.log('Date', date.getFullYear() + '/' + date.getMonth() + '/' + date.getDate())

      // return (thisTime.getTime() + 24*60*60*1000*2) > updataTime.getTime()

      return (thisTime.getTime()) > updataTime.getTime()

    },

    See (e) {
      if (e == "" || e == null) {
        return false;
      } else {
        window.open(e, "_blank");
      }
      // window.location.href = e
    },
    initSwiper () {
      let that = this
      setTimeout(() => {
        new Swiper(".swiper-container-a", {
          effect: "slide",
          spaceBetween: 30,
          // autoHeight: true,
          observer: true,
          observeParents: true,
          loop: false,
          pagination: {
            el: ".swiper-pagination-a",
            clickable: true,
          },
          navigation: {
            nextEl: '.swiper-button-next-a', //前进按钮的css选择器或HTML元素。
            prevEl: '.swiper-button-prev-a', //后退按钮的css选择器或HTML元素。
            hideOnClick: true, //点击slide时显示/隐藏按钮
            disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
            hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
          },
          // autoplay: 5000,
          autoplay: {
            delay: 6000, // 设置轮播的时间
            disableOnInteraction: false, // 这一行是为了避免手动滑动轮播图后，自动轮播失效，默认为true
          },
          on: {
            click: (e) => {
              // if (e.target.id == 0 || e.target.id == 1 || e.target.id == 2 || e.target.id == 3) {
              //   var VueScrollTo = require('vue-scrollto')
              //   var options = {
              //     container: 'body',
              //     duration: 0,
              //     easing: 'ease',
              //     offset: 0,
              //     force: true,
              //     cancelable: true,
              //     onStart: false,
              //     onDone: false,
              //     onCancel: false,
              //     x: false,
              //     y: true
              //   }
              //   var cancelScroll = VueScrollTo.scrollTo(this.el, 500, options)
              //   console.log(e.target)
              //   console.log(e.target.id)
              // } else {
              //   return false
              // }

              // cancelScroll()
              // this.goAnchor()
              // console.log('cancelScroll()', cancelScroll)
              // console.log('VueScrollTo', VueScrollTo)
              // return this.el = '#conbox'

            }
          }
          // direction:"horizontal", /*横向滑动*/
          // loop:true, //形成环路（即：可以从最后一张图跳转到第一张图
          // pagination:".swiper-pagination", /*分页器*/
          // autoplay:3000 /*每隔3秒自动播放*/
        });
        // this.$nextTick(()=>{
        //   this.show = true
        // })
      }, 300)
    },
    goAnchor (e) {
      return this.el = '#conbox'
    },
    showPopup () {
      this.show = true;
    },
    showPopupPdf (e) {
      this.showpdf = true
      this.pdfdow = this.carsQList[e]
      console.log('e', e)
    },
    countTime () {
      //获取当前时间
      var date = new Date()
      var now = date.getTime()
      //设置截止时间
      var endDate = new Date('2020/8/27 21:00:00')
      var end = endDate.getTime()
      //时间差
      var leftTime = end - now
      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        this.time.d = Math.floor(leftTime / 1000 / 60 / 60 / 24)//天数我没用到，暂且写上
        this.time.h = Math.floor((leftTime / 1000 / 60 / 60) % 24)
        this.time.m = Math.floor((leftTime / 1000 / 60) % 60)
        this.time.s = Math.floor((leftTime / 1000) % 60)
      }
      // console.log(this.time)
      //递归每秒调用countTime方法，显示动态时间效果
      setTimeout(this.countTime, 1000)
    },
    selectFn (e) {
      return e.currentTarget.parentElement.classList.add('active')
    },
    selectBr (e) {
      return e.currentTarget.parentElement.classList.remove('active')
    },
    selectChange (e) {
      // console.log('e', e)
      // console.log('ys', this.Yn)
      if (this.Yn == 'yes') {

      }
    },
    checkboxCl (e, p) {
      // console.log('p', p)
      // console.log('e', e.target.checked)
      if (e.type == 'change') {
        if (e.target.checked == true) {
          return e.currentTarget.nextElementSibling.classList.add('active')
        } else if (e.target.checked == false) {
          return e.currentTarget.nextElementSibling.classList.remove('active')
        }
      }
    },
    radioCl (e) {
      // console.log('e', e.target.value)
      this.formData.sex = e.target.value
      // this.$set(this.formData, this.formData.sex, e.target.value)
      // console.log('e', this.formData.sex)
    },

    onSubmit () {
      let _ = this.formData
      let data = {
        activitiCode: _.activitiCode,
        extend2: _.extend2,
        cch: _.cch,   //系列ID
        surname: _.surname,
        name: _.name,
        // birthYear: _.birthYear,
        // birthMonth: _.birthMonth,
        // birthDay: _.birthDay,
        // sex: _.sex == 1 ? "男" : "女",
        sex: '',
        appointDate: _.selDate,
        appointTime: _.selTime,
        phone: _.phone,
        email: _.email,
        isAudi: this.Yn == 'yes' ? 'YES' : 'NO',
        language: _.language,
        carBrand: _.carBrand,
        audiCarModel: _.audiCarModel,
        extend1: _.Privacy3 == true ? false : true,
      }
      console.log('data', data)
      this.$validator.validate().then(result => {
        // console.log('ed', this.formData)
        if (!result) {
          Toast({ message: this.errors.all()[0], duration: 1500 });  // ui框架的提示弹窗
          return
        } else {
          this.load = true
          // if (this.valuationForm.Privacy_yn == true) {
          let _ = this.formData
          let data = {
            activitiCode: _.activitiCode,
            extend2: _.extend2,
            cch: _.cch,   //系列ID
            surname: _.surname,
            name: _.name,
            // birthYear: _.birthYear,
            // birthMonth: _.birthMonth,
            // birthDay: _.birthDay,
            sex: _.sex == 1 ? "男" : "女",
            appointDate: _.selDate,
            appointTime: _.selTime,
            phone: _.phone,
            email: _.email,
            isAudi: this.Yn == 'yes' ? 'YES' : 'NO',
            language: _.language,
            carBrand: _.carBrand,
            audiCarModel: _.audiCarModel,
            extend1: _.Privacy3 == true ? false : true,
          }
          setTimeout(() => {
            reqAddCustomer(data).then(res => {
              if (res.code == 200) {
                this.load = false
                Toast({ message: '謝謝你的登記。我們將盡快與你聯絡。', className: 'myToastCn', duration: 2500 })
                // Toast({type: 'success', duration: 2000})
                this.reload()
              }
            })
          }, 700)
          // } else {
          //   this.load = false

          //   Toast({message: '*This is required.', duration: 2000});  // ui框架的提示弹窗
          // }
          //  this.handleSaveParam();   // 验证通过后请求接口的方法
        }
      })
    }

  },
  destroyed () {
    this.show = false
  },

};
</script>

<style lang="stylus" ref="stylesheet/stylus" scoped>
sub, sup {
  top: 0;
  line-height: inherit;
}

.no {
  display: none;
}

.yes {
  display: block !important;
}

h4 {
  margin: 0;
}

strong {
  font-weight: 700;
}

.audiTxtTypeNormal {
  font-family: 'AudiTypeNormal' !important;
}

.audiTxtExtendedNormal {
  font-family: 'AudiTypeExtendedNormal' !important;
}

.audiTxtExtendedBold {
  font-family: 'AudiTypeExtendedBold' !important;
}

.font28 {
  font-size: 24px !important;
}

h3 {
  font-size: 36px;
}

.m1 {
  font-size: 30px;
}

#home {
  padding-top: 68px;
  font-family: '微軟正黑體', '新細明體', 'AudiTypeNormal', Verdana, Geneva, sans-serif;

  .img-box {
    position: relative;
    width: 100%;
    // height: 35vw;
    // height: 31vw;
    // max-height: 600px;
    height: 56vw;
    max-height: 1096px;
    background: url('../../picture/Audi_S3_Banner_Desktop_20210223_V5.jpg') no-repeat center;
    background-size: 100%;

    .baseTi {
      position: relative;
    }

    #banner {
      text-align: center;
      overflow: hidden;
    }

    #banner {
      margin: 0 auto;
      position: relative;
      // width: 1440px;
      width: 100%;
      background: #fff;

      .boxa {
        width: 100%;
        height: 100%;
        display: inline-block;
        position: relative;
        // width: 100%;
        // height: 35vw;
        // max-height: 600px;
        // background: url(../../picture/banner1_cn.jpg) no-repeat center;
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;

        .bg {
          span {
            font-family: 'GillSansBold', 'Microsoft YaHei', Arial, sans-serif;
            font-size: 19px;
            background: rgba(0, 0, 0, 0.7);
            color: #fff;
            padding: 8px 10px;
            width: 100%;
            display: inline-block;
          }
        }

        img {
          width: 100%;
          // max-width: 1440px;
          margin: 0 auto;
        }
      }

      .swiper-slide {
        background: #fff;
      }

      .swiper-container-a {
        // overflow: initial;
        .swiper-wrapper {
          // height: auto;
          cursor: pointer;
        }
      }

      .swiper-pagination {
        width: 100%;
        bottom: 16px;
        // padding: 5px 0;
      }

      .swiper-button-prev-a {
        left: 8px;
      }

      .swiper-button-next-a {
        right: 8px;
      }

      .swiper-button-next-a, .swiper-button-prev-a {
        padding: 0 6px;
        width: auto;
        height: 46px;
        line-height: 46px;
        opacity: 0.9;
        color: #fff;
        background-image: none;
        background: rgba(0, 0, 0, 0.1);
        display: flex;
        cursor: pointer;
        -webkit-transition: all 0.2s ease-in-out;
        -o-transition: all 0.2s ease-in-out;
        transition: all 0.2s ease-in-out;

        &::before {
          font-size: 20px;
        }

        &:hover {
          background: rgba(0, 0, 0, 0.2);
          opacity: 1;
        }
      }
    }

    .baseBg {
      position: relative;
      z-index: 5;
      display: none;
      width: 100%;
      vertical-align: middle;
    }

    .overlayTxt {
      position: absolute;
      top: 0px;
      left: 0px;
      width: 100%;
      height: 100%;
      z-index: 100;

      .col {
        text-align: left;
        // vertical-align: middle;
        vertical-align: bottom;
      }

      .txtInner {
        // width: 92%;
        width: 86%;
        margin: 0px auto;

        h1 {
          margin-top: 8px;
          margin-bottom: 54px;
          // margin: 0 0 40px 0;
          font-weight: 700;
          color: #000;
          line-height: 1.25;
          font-size: 42px;
        }

        p {
          margin: 0;
          font-size: 32px;
          // font-size: 24px;
          line-height: 1.35;
          color: #000;
          font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
          font-weight: 400;
          // text-shadow: 2px 2px 2px rgba(150, 150, 150, 0.5);
        }

        .h1-logo, .h1-logo-fff {
          margin-bottom: 30px;
          width: 180px;
          height: auto;
          display: none;

          img {
            width: 100%;
          }
        }

        .h1-logo-fff {
          display: block;
        }
      }
    }

    .ctaRow {
      width: 50%;
      min-width: 144px;

      .more {
        margin-bottom: 56px;
        padding: 18px 80px 18px;
        display: flex;
        // padding: 0 58px 0;
        // height: 66px;
        text-align: center;
        flex-direction: column;
        justify-content: center;
        background: #000;
        border: none;
        font-size: 16px;
        color: #fff;
        font-weight: 400;
        -webkit-transition: all 0.35s ease-in-out;
        transition: all 0.35s ease-in-out;
        cursor: pointer;
      }

      .mmo {
        float: left;
        // &:last-child {
        // margin-left: 20px;
        // }
      }
    }
  }

  .text-box {
    text-align: left;

    .inner {
      padding: 50px 0px 10px;
      width: 86%;
      margin: 0px auto;
    }

    h1 {
      font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
      font-weight: 700;
      color: #1d1d1b;
      line-height: 1.25;
      font-size: 36px;
      margin-bottom: 24px;
    }

    p {
      font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
      font-size: 16px;
      line-height: 1.5;
      color: #1d1d1b;
      font-weight: 400;
      text-decoration: none;
    }

    .text-pdf {
      margin-bottom: 36px;
      font-size: 24px;

      span {
        display: block;
      }

      a {
        display: inline-block;
        font-weight: 600;
        line-height: 1.7;
        color: #f50537;
        cursor: pointer;
      }
    }

    h4 {
      font-size: 32px;
      font-weight: 600;
      margin-bottom: 20px;
    }

    .text-ul {
      font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
      font-weight: 400;
      color: #1d1d1b;

      .text-li {
        span {
          font-size: 14px;
        }
      }
    }

    .text-official {
      font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
      margin-top: 16px;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .btn-box {
    // padding: 10px 0 80px;
    padding: 0 0 40px;
    text-align: center;

    .button {
      display: inline-block;
      // padding: 14px 36px 13px;
      padding: 11px 90px 11px;
      width: 320px;
      min-width: 150px;
      background: #000;
      border: none;
      font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
      font-size: 16px;
      line-height: 1.35;
      color: #fff;
      border: 1px solid #000;
      -webkit-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out;
      cursor: pointer;
      font-weight: 400;

      &:hover {
        opacity: 0.7;
      }
    }

    &.register {
      padding: 0 0 40px;

      .button {
        padding: 16px 60px 16px;
      }
    }
  }

  .con-box {
    width: 86%;
    margin: 20px auto 70px;

    h2 {
      margin: 0px auto;
      font-size: 46px;
      font-weight: 700;
      color: #000000;
      line-height: 1.35;
      margin-bottom: 35px;
    }

    p {
      width: 100%;
      margin: 0px auto;
      font-weight: 400;
      color: #999999;
      line-height: 1.35;
      font-size: 20px;
      margin-bottom: 35px;
    }

    button {
      display: inline-block;
      padding: 14px 36px 13px;
      min-width: 150px;
      margin-right: 2.5%;
      background: #ffffff;
      border: none;
      font-size: 16px;
      line-height: 1.35;
      color: #333333;
      border: 1px solid #000000;
      -webkit-transition: all 0.35s ease-in-out;
      transition: all 0.35s ease-in-out;
      cursor: pointer;
      font-family: 'AudiTypeNormal', Verdana, Geneva, sans-serif;
      font-weight: 400;
    }

    .formRow {
      font-size: 0px;
      margin-bottom: 15px;
    }

    // .tWrap {
    // display: table;
    // width: 100%;
    // height: 100%;
    // .tRow {
    // display: table-row;
    // width: 100%;
    // }
    // }
    .lCol, .rCol {
      width: 49%;
      text-align: left !important;
      vertical-align: top !important;
    }

    // .tCell {
    // display: table-cell;
    // vertical-align: middle;
    // text-align: center;
    // }
    .sepCol {
      width: 2%;
    }

    .ctaRow {
      width: 50%;
      min-width: 144px;

      button.primary {
        color: #ffffff;
        background: #000000;
        border: 1px solid #000000;

        &:hover {
          opacity: 0.7;
        }
      }
    }

    .fieldInner {
      margin-left: -2.5%;
      font-size: 0px;

      &.aa > label {
        color: #bb0a30;
      }
    }

    .row00 {
      .lCol, .rCol {
        width: 100%;

        .inputFieldGroup {
          width: 100%;
        }
      }
    }

    .row01 {
      .lCol {
        .inputFieldGroup {
          &:first-child {
            width: 27.5%;
          }

          &:last-child {
            width: 67.5%;
          }
        }
      }
    }

    .row03 {
      .lCol {
        .inputFieldGroup {
          width: 27.5%;

          &:nth-child(2) {
            width: 37.5%;
          }
        }
      }
    }

    .row04 {
      .lCol {
        .fieldInner > label {
          margin-left: 2.5%;
        }

        .inputFieldGroup {
          &:nth-child(2) {
            width: 12.5%;

            label {
              padding-top: 20px;
              padding-bottom: 10px;
            }
          }

          &:nth-child(3) {
            width: 82.5%;
          }
        }
      }
    }

    .inputFieldGroup {
      width: 97.5%;
      position: relative;
      margin-left: 2.5%;
      display: inline-block;
      vertical-align: top;

      .errorField {
        color: #bb0a30;
        font-size: 14px;
        font-family: 'AudiTypeNormal', Verdana, Geneva, sans-serif;
        line-height: 1.35;
        font-weight: 300;
      }

      &.hasError > label {
        color: #bb0a30;
      }
    }

    label {
      display: block;
      font-size: 18px;
      text-align: left;
      line-height: 1.35;
      z-index: 1;
      font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.6);

      sup {
        color: #bb0a30;
        font-size: 12px;
        position: absolute;
      }
    }

    .inputField {
      position: relative;
      width: 100%;
      display: inline-block;
      padding-bottom: 10px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.3);
      -webkit-transition: all 0.5s ease-out;
      transition: all 0.5s ease-out;
      padding-top: 20px;
      margin-bottom: 5px;

      &.selection {
        &.active:before {
          -ms-transform: rotate(180deg);
          -webkit-transform: rotate(180deg);
          transform: rotate(180deg);
        }

        &:before {
          position: absolute;
          display: block;
          content: '';
          bottom: 18px;
          right: 0px;
          width: 13px;
          height: 8px;
          margin-top: -4px;
          background: url('../../images/img-down-arrow.svg') center center no-repeat;
          background-size: cover;
          -webkit-transition: all 0.35s ease-in-out;
          transition: all 0.35s ease-in-out;
          -ms-transform: rotate(0deg);
          -webkit-transform: rotate(0deg);
          transform: rotate(0deg);
          pointer-events: auto;
        }
      }

      &:hover {
        display: inline-block;
        border-bottom: 1px solid rgba(0, 0, 0, 1);

        &:after {
          border-bottom: 1px solid rgba(0, 0, 0, 1);
        }
      }

      select {
        position: relative;
        display: block;
        width: 100%;
        color: rgba(0, 0, 0, 0.6);
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        font-size: 18px;
        line-height: 1.35;
        z-index: 5;
        font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
        font-weight: 300;
        outline: 0;
        border: none;
        background-color: transparent;
      }

      input {
        margin: 0;
        padding: 0;
        border: 0;
        outline: 0;
        vertical-align: baseline;
        background: transparent;
        position: relative;
        width: 100%;
        color: rgba(0, 0, 0, 0.6);
        font-size: 18px;
        line-height: 1.35;
        z-index: 5;
        font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
        font-weight: 300;
      }

      &:after {
        content: '';
        position: absolute;
        bottom: 0px;
        width: 100%;
        left: 0px;
        border-bottom: 1px solid rgba(0, 0, 0, 0);
        -webkit-transition: all 0.5s ease-out;
        transition: all 0.5s ease-out;
      }

      &.hasError {
        border-bottom: 1px solid rgba(187, 10, 48, 1);

        &:after {
          border-bottom: 1px solid rgba(187, 10, 48, 1);
        }
      }
    }

    .radioField {
      font-size: 0px;
      padding-top: 20px;
      margin-bottom: 5px;

      .radioOption {
        display: inline-block;
        width: 27.5%;

        input {
          display: inline-block;
          color: #000000;
          width: 28px;
          height: 28px;
          -webkit-border-radius: 50px;
          -moz-border-radius: 50px;
          border-radius: 50px;
          vertical-align: middle;
          margin-right: 10px;
          outline: none;
        }

        label {
          display: inline-block;
          vertical-align: middle;
        }

        .errorField {
          color: #bb0a30;
          font-size: 14px;
          font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
          line-height: 1.35;
          font-weight: 300;
          display: none;
        }
      }
    }

    .agreeRow {
      width: 100%;
      margin-bottom: 50px;

      p {
        display: block;
        margin: 0px auto 20px;
        font-size: 15px;
        line-height: 1.45;
        color: #333333;
        width: 100%;
        font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
        font-weight: 400;

        a {
          color: #333;

          &:hover {
            color: #333;
          }
        }
      }

      .agreeOptionRow {
        margin-bottom: 10px;

        .checkCol {
          width: 30px;
          text-align: left;
          vertical-align: top;

          label {
            position: relative;
            display: block;
            width: 24px;
            height: 24px;
            border: 1px solid #333333;
            background: #ffffff;

            &.active {
              &:before {
                opacity: 1;
              }
            }

            &:before {
              content: '✔';
              width: 20px;
              height: 20px;
              position: absolute;
              top: 50%;
              left: 50%;
              margin-top: -12px;
              margin-left: -8px;
              opacity: 0;
              -webkit-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
            }
          }
        }

        .sepCol {
          width: 10px;
        }

        .txtCol {
          text-align: left;
          vertical-align: top;
          padding-top: 0;

          p {
            margin: 0px;

            a {
              display: inline-block;
              font-size: 15px;
              line-height: 1.35;
              color: #666666;
              font-family: 'AudiTypeNormal', Verdana, Geneva, sans-serif;
              font-weight: 400;
              text-decoration: underline;
              -webkit-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;
            }
          }
        }

        .formSection {
          width: 100%;
          background: #fafafa;
          overflow: hidden;
          padding: 0px;

          .errorField {
            color: #bb0a30;
            font-size: 14px;
            font-family: 'AudiTypeNormal', Verdana, Geneva, sans-serif;
            line-height: 1.35;
            font-weight: 300;
            margin-left: -2.5%;
            // visibility: hidden;
          }
        }
      }
    }
  }

  .car-box {
    width: 86%;
    margin: 0 auto 30px;

    ul {
      font-size: 0px;
      margin-left: -3.5%;

      li {
        margin-left: 3.5%;
        display: inline-block;
        width: 46.5%;
        vertical-align: top;
        position: relative;
        padding-left: 0px;
        font-size: 18px;
        line-height: 1.35;
        color: #1d1d1b;
        font-weight: 400;
        margin-bottom: 28px;

        a {
          display: block;
        }

        .tmbRow {
          margin-bottom: 18px;

          img {
            width: 100%;
            height: auto;
          }
        }

        .descRow {
          text-align: left;
          font-size: 22px;
          line-height: 1.35;
          color: #1d1d1b;
          font-weight: 600;

          h4 {
            font-family: 'AudiTypeExtendedBold', '微软雅黑', '新細明體', Verdana, Geneva, sans-serif;
            font-size: 26px;
            font-weight: 600;
            margin-bottom: 10px;
          }

          .h4-price {
            font-size: 24px;
            margin-bottom: 0 !important;
          }

          .car-title {
            font-family: 'AudiTypeNormal', '微软雅黑', '新細明體', Verdana, Geneva, sans-serif;
            margin-bottom: 10px;
            // font-size: 14px;
            // font-weight: 400;
            // line-height: 1.45;
          }

          .car-p {
            font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
            margin-bottom: 13px;
            // font-size: 16px;
            font-size: 20px;
            font-weight: 500;
            line-height: 1.5;

            .car-p-li {
              position: relative;
              padding-left: 13px;
              padding-left: 0;

              &.ff {
                padding-left: 13px;

                &:after {
                  content: '-';
                }
              }

              &:after {
                // content: "-";
                display: block;
                position: absolute;
                left: 0;
                top: 0;
              }

              &.no-after {
                &:after {
                  content: '-';
                  display: none;
                  position: absolute;
                  left: 0;
                  top: 0;
                }
              }

              .car-p-li-s {
                position: relative;
                padding-left: 20px;
                counter-increment: lis;

                &:after {
                  content: counter(lis) '.';
                  display: block;
                  position: absolute;
                  left: 0;
                  top: 0;
                }
              }
            }
          }

          .car-p-text {
            font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
            font-size: 20px;
            font-weight: 500;
            line-height: 1.5;
          }

          span {
            font-size: 18px;
            display: inline-block;
            text-align: left;
            line-height: 1.35;

            a {
              font-weight: 400;
              text-decoration: none;
              color: #000;
              -webkit-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;

              &:hover {
                color: #f32034;
              }
            }
          }
        }
      }
    }
  }

  .car-boxbottom {
    width: 100%;
    margin: 0 auto 30px;

    h3 {
      width: 83%;
      margin: 0 auto 32px;
    }

    ul {
      font-size: 0px;
      margin-left: 0;

      li {
        margin-bottom: 16px;
        padding-left: 0px;
        display: inline-block;
        width: calc(50% - 8px);
        vertical-align: top;
        position: relative;
        font-size: 18px;
        line-height: 1.35;
        color: #1d1d1b;
        font-weight: 400;

        &:nth-child(even) {
          margin-left: 16px;
        }

        .tmbRow {
          position: relative;

          a {
            display: block;

            img {
              width: 100%;
              height: auto;
              display: block;
            }
          }
        }

        .descRow {
          padding: 14px 0 14px 16px;
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          text-align: left;
          font-size: 22px;
          line-height: 1.35;
          color: #fff;
          font-weight: 600;
          background-image: -moz-linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.9));
          background-image: -webkit-linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.9));
          background-image: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.9));

          h4 {
            font-family: 'AudiTypeExtendedBold', '微软雅黑', '新細明體', Verdana, Geneva, sans-serif;
            font-size: 26px;
            font-weight: 600;
          }

          .h4-price {
            font-size: 24px;
            margin-bottom: 0 !important;
          }

          .car-title {
            font-family: 'AudiTypeNormal', '微软雅黑', '新細明體', Verdana, Geneva, sans-serif;
            margin-bottom: 10px;
            // font-size: 14px;
            // font-weight: 400;
            // line-height: 1.45;
          }

          .car-p {
            font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
            margin-bottom: 13px;
            // font-size: 16px;
            font-size: 20px;
            font-weight: 500;
            line-height: 1.5;

            .car-p-li {
              position: relative;
              padding-left: 13px;
              padding-left: 0;

              &.ff {
                padding-left: 13px;

                &:after {
                  content: '-';
                }
              }

              &:after {
                // content: "-";
                display: block;
                position: absolute;
                left: 0;
                top: 0;
              }

              &.no-after {
                &:after {
                  content: '-';
                  display: none;
                  position: absolute;
                  left: 0;
                  top: 0;
                }
              }

              .car-p-li-s {
                position: relative;
                padding-left: 20px;
                counter-increment: lis;

                &:after {
                  content: counter(lis) '.';
                  display: block;
                  position: absolute;
                  left: 0;
                  top: 0;
                }
              }
            }
          }

          .car-p-text {
            font-family: 'AudiTypeNormal', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
            font-size: 20px;
            font-weight: 500;
            line-height: 1.5;
          }

          span {
            font-size: 18px;
            display: inline-block;
            text-align: left;
            line-height: 1.35;

            a {
              font-weight: 400;
              text-decoration: none;
              color: #000;
              -webkit-transition: all 0.35s ease-in-out;
              transition: all 0.35s ease-in-out;

              &:hover {
                color: #f32034;
              }
            }
          }
        }
      }
    }
  }

  .blog-wrapper {
    margin: 20px auto 60px;
    width: 86%;

    .ul {
      margin-right: -3.5%;
      margin-left: 0;
      -webkit-box-align: stretch;
      -ms-flex-align: stretch;
      align-items: stretch;
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -ms-flex-wrap: wrap;
      flex-wrap: wrap;
      -webkit-box-pack: justify;
      -ms-flex-pack: justify;
      justify-content: space-between;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;

      .li {
        margin-right: 3.5%;
        margin-bottom: 46px;
        padding: 0;
        width: 46.5%;
        font-size: 26px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;

        img {
          width: 100%;
        }

        .tent {
          margin-top: 6px;

          strong {
            font-family: 'AudiTypeExtendedBold', '微軟正黑體', '新細明體', Verdana, Geneva, sans-serif;
          }

          p {
            margin-top: 12px;
            margin-bottom: 0;
            font-size: 22px;
            line-height: 1.45;
          }
        }
      }
    }
  }

  .gallery-wrapper {
    margin: 20px auto 60px;
    width: 86%;

    &:last-of-type {
      margin-top: -18px;
    }

    .ul {
      width: 100%;
      // margin-right: -3.5%;
      // margin-left: 0;
      box-sizing: border-box;
      overflow: hidden;

      .li {
        float: left;
        width: 40%;
        padding-bottom: 40%;
        margin: 0%;
        position: relative;
        overflow: hidden;
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;

        &:nth-child(2), &:nth-child(5) {
          padding-bottom: 20%;
        }

        &:nth-child(3), &:nth-child(4) {
          width: 20%;
          padding-bottom: 20%;
        }

        &::after {
          position: absolute;
          right: 10px;
          top: 10px;
          display: block;
          height: 30px;
          width: 30px;
          background: #000 url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAhElEQVR4nO2YQQqAMAwEs+L/vxwvegsq3bYudufYggwDgVRkZoYw29cCT1iQRV5wrw4BYLZIREQ1sPIFLchiQRYLsqwlmCc9v7lWwRFYkKXcZt5wNwzVXeuG9N+CVZGrXM99Ur6gBVnkBZuHpGLEY0u+oAVZLMhiQRZ5QfgXMIkFWeQFD/FPIEvfCKErAAAAAElFTkSuQmCC') no-repeat 50%;
          box-shadow: 0 0 0 5px rgba(255, 255, 255, 0.333);
          content: '';
          pointer-events: none;
          cursor: pointer;
        }

        img {
          position: absolute;
          width: 100%;
          height: 100%;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          opacity: 0;
          cursor: pointer;
        }
      }
    }
  }

  .nm-box {
    margin-top: 70px;
    margin-bottom: 110px;
    font-family: 'AudiTypeExtendedNormal' !important;

    h5 {
      margin-top: 0;
      margin-bottom: 32px;
      font-size: 42px;
      font-weight: 700;
      text-align: center;
    }

    .nm-box-ul {
      display: -webkit-box;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-pack: center;
      -ms-flex-pack: center;
      justify-content: center;

      .nm-box-li {
        margin: 0 2% 0 30px;
        padding-right: 30px;
        padding-bottom: 2px;
        display: inline-block;
        width: calc(100% - 60px);
        border-bottom: rgba(0, 0, 0, 0.1);
        border-color: rgba(0, 0, 0, 0.1) currentcolor;
        border-right: 1px solid;
        overflow: hidden;
        -webkit-transition: all 0.75s cubic-bezier(0.445, 0.05, 0.55, 0.95);
        transition: all 0.75s cubic-bezier(0.445, 0.05, 0.55, 0.95);

        /* width: 28%; */
        &:last-of-type {
          border: none !important;
          margin-bottom: 0;
        }

        p {
          margin-top: 0;
          font-size: 16px;
        }

        .nm-box-title {
          display: -webkit-box;
          display: -ms-flexbox;
          display: flex;
          height: 60px;
          justify-content: center;
          margin-bottom: 18px;
          overflow: hidden;

          span {
            align-self: flex-end;
            font-weight: 700;
          }
        }

        .nm-box-number {
          display: flex;
          justify-content: center;
          margin-bottom: 18px;

          .nm-box-figure {
            font-size: 66px;
            line-height: 96px;
          }

          .nm-box-unit {
            display: inline-block;
            align-self: flex-end;
            margin-left: 12px;
            margin-bottom: 20px;
            font-size: 16px;
            font-weight: 600;
            line-height: 18px;
          }
        }

        .nm-box-m {
          display: flex;
          justify-content: center;
          font-weight: 600;
        }
      }
    }
  }

  .chatbox-float {
    position: fixed;
    bottom: 50%;
    right: 0;
    z-index: 1111;
    margin-bottom: -35px;

    .popup-icon-btn {
      position: relative;
      bottom: 0;
      right: 0;
      z-index: 1111;
      padding-top: 0;
      width: 64px;
      height: 70px;
      color: #fff;
      background: url('../../images/groups-large-fff-2x.png') #f50537 no-repeat center bottom;
      background-size: 82%;
      cursor: pointer;

      &:before {
        position: absolute;
        top: 3px;
        left: 0;
        content: '在線聊天';
        font-size: 13px;
        font-weight: 500;
        text-align: center;
        width: 100%;
        height: 12px;
        line-height: 12px;
        background: #f50537;
        -ms-transform: scale(0.9);
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
      }
    }

    .popup-icon-box {
      position: relative;
      // bottom: -70px;
      bottom: 0;
      right: 0;
      z-index: 1110;

      // opacity: 0;
      // -ms-transition: all 0.6s ease 0s;
      // -webkit-transition: all 0.6s ease 0s;
      // transition: all 0.6s ease 0s;
      a {
        position: absolute;
        bottom: -70px;
        display: block;
        width: 64px;
        height: 70px;
        opacity: 0;
        -ms-transform: scale(0.9);
        -webkit-transform: scale(0.9);
        transform: scale(0.9);
        -ms-transition: all 0.6s ease 0s;
        -webkit-transition: all 0.6s ease 0s;
        transition: all 0.6s ease 0s;
        cursor: pointer;
      }

      .whatsapp-icon {
        background: url('../../images/i-whatsapp.svg') no-repeat center center;
        background-size: contain;

        &.cut {
          bottom: 70px;
          opacity: 1;
        }
      }

      .facebook-icon {
        background: url('../../images/i-facebook.svg') no-repeat top center;
        background-size: contain;

        &.cut {
          bottom: 0;
          opacity: 1;
        }
      }
    }
  }
}

// 日期
.datePicker {
  padding-top: 26px;
  position: absolute;
  z-index: 999;
  top: 57px;
  left: 0;
  box-shadow: 0 0 5px 0px rgba(0, 0, 0, 0.1);

  .close {
    position: absolute;
    top: 8px;
    right: 12px;
    width: 16px;
    height: 16px;
    z-index: 9999;
    cursor: pointer;
    background: url('../../images/close.svg') no-repeat;
    background-size: cover;
  }
}

@media screen and (max-width: 1660px) {
  #home {
    .img-box {
      .overlayTxt {
        .txtInner {
          h1 {
            margin-top: 8px;
            margin-bottom: 44px;
            font-size: 2.4vw;
          }

          p {
            // font-size: 1.484vw;
            font-size: 2vw;
          }

          .h1-logo, .h1-logo-fff {
            margin-bottom: 22px;
            max-width: 160px;
            width: 10.4vw;
          }
        }

        .ctaRow {
          .more {
            margin-bottom: 32px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1440px) {
  .font28 {
    font-size: 20px !important;
  }

  #home {
    .img-box {
      // height: 35vw;
      // max-height: 600px;
      .overlayTxt {
        .txtInner {
          h1 {
            // margin-bottom: 30px;
            // margin-bottom: 15px;
            // font-size: 34px;
          }

          p {
            // margin-bottom: 14px;
            // font-size: 24px;
          }

          .h1-logo, .h1-logo-fff {
            // margin-bottom: 30px;
            // margin-bottom: 50px;
            // width: 160px;
            height: auto;
            display: none;

            img {
              width: 100%;
            }
          }

          .h1-logo-fff {
            display: block;
          }
        }
      }

      .ctaRow {
        width: 50%;
        min-width: 144px;

        .more {
          padding: 16px 60px 16px;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }

    .text-box {
      .inner {
        padding: 60px 0 0 0;
      }
    }

    .nm-box {
      margin-top: 60px;

      h5 {
        margin-bottom: 32px;
        font-size: 30px;
      }

      .nm-box-ul {
        .nm-box-li {
          p {
            margin-top: 0;
            font-size: 16px;
          }

          .nm-box-number {
            .nm-box-figure {
              font-size: 42px;
              line-height: 60px;
            }

            .nm-box-unit {
              margin-bottom: 12px;
              font-size: 14px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1360px) {
  #home {
    .img-box {
      .overlayTxt {
        .txtInner {
          h1 {
            margin-top: 4px;
            margin-bottom: 28px;
            font-size: 2.54vw;
          }

          p {
            font-size: 2.2vw;
          }

          .h1-logo, .h1-logo-fff {
            margin-bottom: 16px;
            width: 11.4vw;
            max-width: 160px;
          }
        }

        .ctaRow {
          .more {
            margin-bottom: 28px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 1150px) {
  #home {
    .img-box {
      // .overlayTxt {
      // .txtInner {
      // h1 {
      // font-size: 32px;
      // }
      // p {
      // font-size: 22px;
      // margin-bottom: 8px;
      // }
      // .h1-logo-fff {
      // width: 146px;
      // }
      // }
      // }
      .ctaRow {
        .more {
          padding: 14px 48px 14px;
          font-size: 15px;
        }
      }
    }
  }
}

@media screen and (max-width: 1024px) {
  strong {
    &.large {
      font-size: 24px;
    }
  }

  .font28 {
    font-size: 18px !important;
  }

  .none1024 {
    display: none;
  }

  .block1024 {
    display: block !important;
  }

  h3 {
    font-size: 34px;
  }

  .m1 {
    font-size: inherit;
  }

  #home {
    .img-box {
      background: #fafafa;
      height: auto;
      max-height: 1000%;

      .times {
        top: 13.45vw;
        left: 50%;
        margin-left: -116px;

        ol {
          font-size: 28px;

          li {
            margin: 0 12px;

            .ququ {
              width: 80px;
              height: 80px;
            }

            span {
              font-size: 16px;
              margin-top: 8px;
            }
          }
        }
      }

      .baseTi {
        position: relative;
      }

      .baseBg {
        position: relative;
        z-index: 5;
        display: block;
        width: 100%;
        height: auto;
      }

      .times {
        z-index: 999;
      }

      .overlayTxt {
        position: relative;
        padding: 60px 0 0;

        .txtInner {
          position: relative;
          width: 86%;
          margin: 0px auto;

          h1 {
            margin-bottom: 20px;
            font-size: 34px;
            width: 100%;
            color: #000000;
          }

          p {
            margin-bottom: 20px;
            font-size: 25px;
            line-height: 1.45;
            color: #000000;
            text-shadow: none;
          }

          .h1-logo, .h1-logo-fff {
            margin-bottom: 50px;
            width: 160px;
            height: auto;
            display: none;

            img {
              width: 100%;
            }
          }

          .h1-logo {
            display: block;
          }

          .h1-logo-fff {
            display: none;
          }
        }
      }

      .ctaRow {
        width: 50%;
        min-width: 144px;

        .more {
          padding: 18px 70px 18px;
          font-size: 16px;
          background: #000000;
          color: #ffffff;
        }
      }
    }

    .text-box {
      .inner {
        // padding: 25px 0px 28px 0px;
        padding: 0 0px 0 0px;
        // width: 100%;
        width: 86%;
      }

      h1 {
        margin-bottom: 20px;
        font-size: 34px;
        color: #000000;
      }

      p {
        font-size: 18px;

        &.f {
          font-size: 24px;
          margin-bottom: 50px;
          color: #000;
          text-shadow: none;
        }
      }
    }

    .con-box {
      h2 {
        font-size: 36px;
        margin-bottom: 35px;
      }

      p {
        font-size: 18px;
        margin-bottom: 35px;
      }

      .formGroup {
        margin-bottom: 0px;

        .formRow {
          font-size: 0px;
          margin-bottom: 15px;
        }

        .lCol, .rCol {
          width: 49%;
          text-align: left;
          vertical-align: top;
        }

        .sepCol {
          width: 2%;
        }

        .row01 {
          .lCol {
            .inputFieldGroup {
              &:first-child {
                width: 27.5%;
              }

              &:last-child {
                width: 67.5%;
              }
            }
          }
        }

        .inputFieldGroup {
          width: 97.5%;

          .errorField {
            font-size: 13px;
          }
        }

        label {
          font-size: 16px;

          sup {
            font-size: 12px;
          }
        }

        .inputField {
          padding-bottom: 10px;
          padding-top: 20px;
          margin-bottom: 5px;

          select {
            font-size: 16px;
          }

          input {
            font-size: 16px;
          }
        }

        .radioField {
          font-size: 0px;
          padding-top: 20px;

          .radioOption {
            display: inline-block;
            width: 27.5%;

            input {
              width: 24px;
              height: 24px;
              margin-right: 10px;
            }
          }
        }

        .agreeRow {
          margin-bottom: 40px;

          p {
            margin-bottom: 20px;
            font-size: 13px;
          }

          .agreeOptionRow {
            margin-bottom: 10px;

            .checkCol {
              width: 30px;
              text-align: left;
              vertical-align: top;

              label {
                width: 20px;
                height: 20px;

                &.active {
                  &:before {
                    opacity: 1;
                  }
                }

                &:before {
                  content: '✔';
                  width: 20px;
                  height: 20px;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  margin-top: -10px;
                  margin-left: -6px;
                  opacity: 0;
                  -webkit-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }

              .txtCol {
                margin: 0px;

                p {
                  a {
                    font-size: 13px;
                  }
                }
              }
            }

            .formSection {
              .errorField {
                font-size: 13px;
              }
            }
          }
        }
      }
    }

    .car-box {
      margin: 0 auto 30px;

      ul {
        li {
          .tmbRow {
            margin-bottom: 16px;
          }

          .descRow {
            font-size: 20px;

            h4 {
              font-size: 24px;
            }

            span {
              // font-size: 14px;
            }

            .h4-price {
              font-size: 22px;
            }

            .car-p-text-price {
              font-size: 18px;
            }
          }
        }
      }
    }

    .car-boxbottom {
      width: 100%;
      margin: 0 auto 30px;

      h3 {
        width: 86%;
      }

      ul {
        margin-left: 0;

        li {
          margin-left: 0;
          margin-bottom: 8px;
          width: calc(50% - 4px);

          &:nth-child(even) {
            margin-left: 8px;
          }

          .tmbRow {
          }

          .descRow {
            padding: 10px 0 10px 12px;
            font-size: 20px;

            h4 {
              font-size: 2.6vw;
            }

            span {
              // font-size: 14px;
            }

            .h4-price {
              font-size: 22px;
            }

            .car-p-text-price {
              font-size: 18px;
            }
          }
        }
      }
    }

    .blog-wrapper {
      .ul {
        .li {
          font-size: 24px;

          .tent {
            p {
              margin-top: 10px;
              font-size: 20px;
            }
          }
        }
      }
    }

    .gallery-wrapper {
      .ul {
        .li {
          width: 50%;
          padding-bottom: 50%;

          &:nth-child(2), &:nth-child(5) {
            width: 25%;
            padding-bottom: 25%;
          }

          &:nth-child(3), &:nth-child(4) {
            width: 25%;
            padding-bottom: 25%;
          }
        }
      }
    }

    .nm-box {
      .nm-box-ul {
        .nm-box-li {
          .nm-box-number {
            .nm-box-figure {
              font-size: 40px;
              line-height: 60px;
            }

            .nm-box-unit {
              margin-bottom: 11px;
              margin-left: 8px;
              font-size: 13px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .font28 {
    font-size: 18px !important;
  }

  .none768 {
    display: none;
  }

  .block768 {
    display: block !important;
  }

  h3 {
    font-size: 27px;
  }

  #home {
    .img-box {
      height: auto;
      max-height: 1000%;

      .baseBg {
        position: relative;
        z-index: 5;
        display: block;
        width: 100%;
        height: auto;
      }

      .overlayTxt {
        position: relative;
        padding: 60px 0 0;

        .txtInner {
          width: 86%;
          margin: 0px auto;

          h1 {
            margin-bottom: 16px;
            font-size: 27px;
          }

          p {
            margin-bottom: 24px;
            font-size: 25px;
            // font-size: 16px;
          }

          .h1-logo, .h1-logo-fff {
            margin-bottom: 50px;
            width: 150px;
            height: auto;
            display: none;

            img {
              width: 100%;
            }
          }

          .h1-logo {
            display: block;
          }

          .h1-logo-fff {
            display: none;
          }
        }
      }

      .ctaRow {
        width: 50%;
        min-width: 240px;

        .more {
          padding: 16px 56px 16px;
          font-size: 16px;
        }
      }
    }

    .text-box {
      .inner {
        // padding: 25px 0px 26px 0px;
        padding: 0 0px 0 0px;
      }

      h1 {
        margin-bottom: 22px;
        font-size: 27px;
      }

      p {
        font-size: 16px;

        &.f {
          font-size: 20px;
          margin-bottom: 44px;
          color: #000;
          text-shadow: none;
        }
      }
    }

    .btn-box {
      .button {
        width: 250px;
        font-size: 14px;
      }

      &.register {
        padding: 0 0 36px;
      }
    }

    .con-box {
      h2 {
        font-size: 24px;
        margin-bottom: 35px;
      }

      p {
        font-size: 16px;
        margin-bottom: 35px;
      }

      .formGroup {
        margin-bottom: 0px;

        .formRow {
          font-size: 0px;
          margin-bottom: 15px;
        }

        .lCol, .rCol {
          display: block;
          width: 100%;
        }

        .sepCol {
          display: block;
          width: 100%;
          height: 20px;
        }

        .row01 {
          .lCol {
            .inputFieldGroup {
              &:first-child {
                width: 27.5%;
              }

              &:last-child {
                width: 67.5%;
              }
            }
          }
        }

        .inputFieldGroup {
          width: 97.5%;
        }

        label {
          sup {
            position: relative;
          }
        }

        .radioField {
          font-size: 0px;
          padding-top: 4vw;

          .radioOption {
            display: inline-block;
            width: 37.5%;

            input {
              width: 24px;
              height: 24px;
              margin-right: 2.5vw;
            }
          }
        }
      }
    }

    .car-box {
      margin: 0 auto 20px;

      ul {
        li {
          .tmbRow {
            margin-bottom: 14px;
          }

          .descRow {
            font-size: 18px;

            h4 {
              font-size: 22px;
            }

            span {
              // font-size: 14px;
            }

            .h4-price {
              font-size: 20px;
            }

            .car-p-text-price {
              font-size: 17px;
            }
          }
        }
      }
    }

    .car-boxbottom {
      margin: 0 auto 20px;

      ul {
        li {
          .tmbRow {
          }

          .descRow {
            font-size: 18px;

            h4 {
              font-size: 2.8vw;
            }

            span {
              // font-size: 14px;
            }

            .h4-price {
              font-size: 20px;
            }

            .car-p-text-price {
              font-size: 17px;
            }
          }
        }
      }
    }

    .blog-wrapper {
      .ul {
        .li {
          font-size: 22px;

          .tent {
            p {
              margin-top: 10px;
              font-size: 18px;
            }
          }
        }
      }
    }

    .gallery-wrapper {
      .ul {
        .li {
          width: 100%;
          padding-bottom: 50%;

          &:nth-child(2), &:nth-child(5) {
            width: 66.8%;
            padding-bottom: 33.4%;
          }

          &:nth-child(3), &:nth-child(4) {
            width: 33.2%;
            padding-bottom: 33.4%;
          }
        }
      }
    }

    .nm-box {
      margin-top: 36px;
      margin-bottom: 58px;

      h5 {
        margin-bottom: 36px;
        font-size: 30px;
      }

      .nm-box-ul {
        .nm-box-li {
          margin: 0;
          padding-right: 0;

          p {
            font-size: 16px;
          }

          .nm-box-number {
            .nm-box-figure {
              font-size: 32px;
              line-height: 42px;
            }

            .nm-box-unit {
              margin-left: 12px;
              margin-bottom: 8px;
              font-size: 12px;
            }
          }
        }
      }
    }

    .chatbox-float {
      margin-bottom: -23px;

      .popup-icon-btn {
        width: 50px;
        height: 56px;

        &:before {
          font-size: 12px;
        }
      }

      .popup-icon-box {
        // bottom: -56px;
        bottom: 0;
        right: 0;

        // &.cut {
        // bottom: 56px;
        // }
        a {
          width: 50px;
          height: 56px;
        }

        .whatsapp-icon {
          &.cut {
            bottom: 56px;
            opacity: 1;
          }
        }

        .facebook-icon {
          &.cut {
            bottom: 0px;
            opacity: 1;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 500px) {
  .font28 {
    font-size: 4.2vw !important;
  }

  strong {
    &.large {
      font-size: 5vw;
    }
  }

  .none500 {
    display: none;
  }

  .block500 {
    display: block !important;
  }

  h3 {
    font-size: 6.2vw;
    margin-bottom: 20px;
  }

  .vw39 {
    font-size: 4vw !important;
  }

  #home {
    padding-top: 48px;

    .img-box {
      height: auto;
      max-height: 1000%;

      // .baseBg {
      // position: relative;
      // z-index: 5;
      // display: block;
      // width: 100%;
      // height: auto;
      // }
      .overlayTxt {
        padding: 10vw 0 0;

        .txtInner {
          h1 {
            margin-bottom: 2.6vw;
            font-size: 6.2vw;
          }

          p {
            margin-bottom: 4vw;
            font-size: 5.1vw;
            // font-size: 4.4vw;
          }

          .h1-logo, .h1-logo-fff {
            margin-bottom: 8vw;
            width: 30vw;
            height: auto;
            display: none;

            img {
              width: 100%;
            }
          }

          .h1-logo {
            display: block;
          }

          .h1-logo-fff {
            display: none;
          }
        }
      }

      .ctaRow {
        width: 50%;
        min-width: 144px;

        .more {
          padding: 4vw 8vw 4vw;
          font-size: 3.6vw;
        }
      }
    }

    .text-box {
      .inner {
        // padding: 25px 0px 0 0px;
        // width: 100%;
      }

      h1 {
        margin-bottom: 4vw;
        font-size: 6vw;
      }

      p {
        font-size: 13px;

        &.f {
          margin-bottom: 8vw;
          font-size: 4vw;
        }
      }

      .text-pdf {
        font-size: 5.2vw;
        margin-bottom: 30px;
      }

      .text-ul {
        .text-li {
          span {
            font-size: 12px;
          }
        }
      }

      h4 {
        font-size: 5.7vw;
      }

      .text-official {
        margin-top: 10px;
        font-size: 12px;
      }
    }

    .btn-box {
      .button {
        padding: 11px 30px 11px;
        min-width: 240px;
      }

      &.register {
        .button {
          padding: 14px 50px 14px;
          min-width: 160px;
        }
      }
    }

    .con-box {
      h2 {
        font-size: 5.6vw;
      }

      .formGroup {
        .row01 {
          .lCol {
            .inputFieldGroup {
              &:first-child {
                width: 27.5%;
              }

              &:last-child {
                width: 67.5%;
              }
            }
          }
        }

        .inputFieldGroup {
          width: 97.5%;

          .errorField {
            font-size: 2.5vw;
          }
        }

        label {
          font-size: 3.5vw;

          sup {
            position: relative;
          }
        }

        .inputField {
          padding-bottom: 2vw;
          padding-top: 4vw;
          margin-bottom: 1vw;

          select {
            font-size: 3.5vw;
          }

          input {
            font-size: 3.5vw;
          }
        }

        .agreeRow {
          margin-bottom: 40px;

          p {
            margin-bottom: 20px;
            font-size: 13px;
          }

          .agreeOptionRow {
            margin-bottom: 10px;

            .checkCol {
              width: 30px;
              text-align: left;
              vertical-align: top;

              label {
                width: 20px;
                height: 20px;

                &.active {
                  &:before {
                    opacity: 1;
                  }
                }

                &:before {
                  content: '✔';
                  width: 20px;
                  height: 20px;
                  position: absolute;
                  top: 50%;
                  left: 50%;
                  margin-top: -10px;
                  margin-left: -6px;
                  opacity: 0;
                  -ms-transition: all 0.35s ease-in-out;
                  -webkit-transition: all 0.35s ease-in-out;
                  transition: all 0.35s ease-in-out;
                }
              }

              .txtCol {
                margin: 0px;

                p {
                  a {
                    font-size: 2.75vw;
                  }
                }
              }
            }

            .formSection {
              .errorField {
                font-size: 2.5vw;
              }
            }
          }
        }
      }
    }

    .car-box {
      margin: 0 auto 20px;

      ul {
        margin-left: 0;

        li {
          width: 100%;
          margin-left: 0;
          margin-bottom: 4.2vw;

          .tmbRow {
            margin-bottom: 12px;
          }

          .descRow {
            font-size: 3.8vw;

            h4 {
              font-size: 5.2vw;
            }

            span {
              font-size: 3.8vw;
            }

            .car-p {
              font-size: 4.2vw;
            }
          }
        }
      }
    }

    .car-boxbottom {
      margin: 0 auto 20px;

      h3 {
        margin: 0 auto 16px;
      }

      ul {
        margin-left: 0;

        li {
          width: 100%;
          margin-left: 0;
          margin-bottom: 3vw;

          &:nth-child(even) {
            margin-left: 0;
          }

          .tmbRow {
            margin-bottom: 0;
          }

          .descRow {
            font-size: 3.8vw;

            h4 {
              font-size: 5.2vw;
            }

            span {
              font-size: 3.8vw;
            }

            .car-p {
              font-size: 4.2vw;
            }
          }
        }
      }
    }

    .blog-wrapper {
      .ul {
        margin-right: 0;

        .li {
          margin-right: 0;
          margin-bottom: 32px;
          font-size: 4vw;
          width: 100%;

          .tent {
            p {
              margin-top: 10px;
              font-size: 13px;
            }
          }
        }
      }
    }

    .gallery-wrapper {
      .ul {
        .li {
          width: 100%;
          padding-bottom: 50%;

          &:nth-child(2), &:nth-child(5) {
            width: 50%;
            padding-bottom: 50%;
          }

          &:nth-child(3), &:nth-child(4) {
            width: 50%;
            padding-bottom: 50%;
          }
        }
      }
    }

    .nm-box {
      h5 {
        margin-bottom: 26px;
        font-size: 6.3vw;
      }

      .nm-box-ul {
        .nm-box-li {
          .nm-box-title {
            height: 42px;
          }

          p {
            font-size: 13px;
          }

          .nm-box-number {
            margin-bottom: 14px;

            .nm-box-figure {
              font-size: 22px;
              line-height: 28px;
            }

            .nm-box-unit {
              margin-left: 4px;
              margin-bottom: 0;
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}

@media screen and (max-width: 360px) {
  .block360 {
    display: block !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/cn/Home.vue